(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  class BestSellersSlider extends HTMLElement {
    connectedCallback() {
      this.sliderWrapper = this.querySelector('.bs-slider-wrapper');
      this.slider = this.querySelector('.bs-slider');
      this.slides = Array.from(this.querySelectorAll('.bs-slide'));
      this.productCards = Array.from(this.querySelectorAll('[data-best-seller-card]'));
      this.prevBtn = this.querySelector('button[name="previous"]');
      this.nextBtn = this.querySelector('button[name="next"]');
      this.dots = Array.from(this.querySelectorAll('.bs-dot'));
      this.dotsContainer = this.querySelector('.bs-dots');

      if (!this.slider || !this.slides.length) return;

      this.currentIndex = 0;
      this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed, 10) || 3500;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.agentContext = this.getAgentContext();
      this.handleResize = this.handleResize.bind(this);
      this.handleActionClick = this.handleActionClick.bind(this);
      this.handleCartUpdated = this.handleCartUpdated.bind(this);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number.parseInt(dot.dataset.index, 10));
          this.resetAutoplay();
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('click', this.handleActionClick);
      document.addEventListener('superior:cart-updated', this.handleCartUpdated);

      this.slider.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.touches[0].clientX;
        },
        { passive: true }
      );

      this.slider.addEventListener('touchend', (event) => {
        const diff = this.touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          this.goTo(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
          this.resetAutoplay();
        }
      });

      window.addEventListener('resize', this.handleResize);

      this.querySelectorAll('.bs-retail-price').forEach((el) => {
        const num = Number.parseFloat(el.dataset.price);
        if (!Number.isNaN(num)) {
          el.textContent = num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
      });

      this.applyAgentContext();
      this.updateDots();
      this.play();
      this.syncCardQuantities();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.pause();
      this.removeEventListener('click', this.handleActionClick);
      document.removeEventListener('superior:cart-updated', this.handleCartUpdated);
    }

    get slidesPerPage() {
      return window.innerWidth >= 990 ? 4 : 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.slidesPerPage);
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.slider.style.transition = 'none';
        this.applyTransform();
        this.updateDots();
        requestAnimationFrame(() => {
          this.slider.style.transition = '';
        });
      }, 100);
    }

    getStep() {
      if (this.slides.length < 2) return this.sliderWrapper.offsetWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    applyTransform() {
      this.slider.style.transform = `translateX(-${this.currentIndex * this.getStep()}px)`;
    }

    goTo(index) {
      const max = this.maxIndex;
      if (index < 0)    index = max;
      if (index > max)  index = 0;
      this.currentIndex = index;
      this.applyTransform();
      this.updateDots();
    }

    updateDots() {
      const max = this.maxIndex;
      const hasMultiplePages = max > 0;
      let visibleDots = 0;

      if (this.prevBtn) {
        this.prevBtn.hidden = !hasMultiplePages;
        this.prevBtn.disabled = !hasMultiplePages;
      }

      if (this.nextBtn) {
        this.nextBtn.hidden = !hasMultiplePages;
        this.nextBtn.disabled = !hasMultiplePages;
      }

      this.dots.forEach((dot, i) => {
        const visible = i <= max;
        const active = visible && i === this.currentIndex;

        dot.hidden = !visible;
        dot.disabled = !visible;
        dot.tabIndex = visible ? 0 : -1;
        dot.classList.toggle('bs-dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');

        if (visible) visibleDots += 1;
      });

      if (this.dotsContainer) {
        this.dotsContainer.hidden = visibleDots < 2;
      }
    }

    play() {
      this.pause();
      if (!this.autoplaySpeed || this.maxIndex === 0) return;
      this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pause() {
      clearInterval(this.autoplayTimer);
    }

    resetAutoplay() {
      this.pause();
      this.play();
    }

    getAgentContext() {
      const origin = this.dataset.sectionAgentOrigin;

      if (origin !== 'agent-shop') return null;

      return {
        origin,
        moq: this.parsePositiveInteger(this.dataset.sectionAgentMoq),
        discountOverride: this.parsePositivePercentage(this.dataset.sectionAgentDiscount),
      };
    }

    parsePositiveInteger(value) {
      const parsedValue = Number.parseInt(String(value ?? ''), 10);
      return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
    }

    parsePositivePercentage(value) {
      const parsedValue = Number.parseFloat(String(value ?? ''));
      if (!Number.isFinite(parsedValue) || parsedValue <= 0) return null;
      return Math.min(parsedValue, 100);
    }

    isBundleCard(card) {
      return String(card?.dataset.productType || '').trim().toLowerCase() === 'bundle';
    }

    getEffectiveDiscount(card) {
      if (!this.agentContext) return null;
      return this.agentContext.discountOverride ?? null;
    }

    getAgentLineItemProperties() {
      if (!this.agentContext) return null;

      const properties = {
        _agent_origin: this.agentContext.origin,
      };

      if (Number.isFinite(this.agentContext.moq) && this.agentContext.moq > 0) {
        properties._agent_shop_moq = `${this.agentContext.moq}`;
      }

      if (Number.isFinite(this.agentContext.discountOverride) && this.agentContext.discountOverride > 0) {
        properties._agent_shop_discount = `${this.agentContext.discountOverride}`;
      }

      return properties;
    }

    formatMoney(cents) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = this.moneyFormat.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';
      const amount = Number(cents) / 100;

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (Number.isNaN(number) || number === null) return '0';

        const fixedNumber = number.toFixed(precision);
        const parts = fixedNumber.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        return parts.join(decimal);
      };

      let formattedValue;
      switch (placeholder) {
        case 'amount_no_decimals':
          formattedValue = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          formattedValue = formatWithDelimiters(amount, 2);
          break;
      }

      return this.moneyFormat.replace(placeholderRegex, formattedValue);
    }

    buildProductUrl(card) {
      const baseUrl = card?.dataset.productUrl;
      if (!baseUrl || !this.agentContext || this.isBundleCard(card)) return baseUrl || '';

      const params = new URLSearchParams();
      params.set('view', 'agent-product');

      const queryString = params.toString();
      if (!queryString) return baseUrl;

      return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${queryString}`;
    }

    applyAgentContext() {
      this.querySelectorAll('[data-best-seller-card]').forEach((card) => {
        const productLink = card.querySelector('[data-product-link]');
        if (productLink) {
          productLink.href = this.buildProductUrl(card) || productLink.href;
        }

        const priceNode = card.querySelector('[data-best-seller-price]');
        if (!priceNode) return;

        const basePriceCents = Number.parseInt(priceNode.dataset.basePriceCents, 10);
        if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) return;

        const effectiveDiscount = this.getEffectiveDiscount(card);
        const discountedPriceCents = effectiveDiscount
          ? Math.round((basePriceCents * (100 - effectiveDiscount)) / 100)
          : basePriceCents;

        priceNode.textContent = this.formatMoney(discountedPriceCents);
      });
    }

    handleCartUpdated(event) {
      const cartState = event.detail?.cart;
      if (!cartState) return;

      this.syncCardQuantities(cartState);
    }

    emitCartUpdated(cartState) {
      if (!cartState) return;

      document.dispatchEvent(
        new CustomEvent('superior:cart-updated', {
          detail: { cart: cartState },
        })
      );
    }

    getSectionsUrl() {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('section_id');
      return `${currentUrl.pathname}${currentUrl.search}`;
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHtml.querySelector(selector) || parsedHtml.body;

      return source.innerHTML;
    }

    syncCartDrawerState(sectionHtml, cart = this.getCartElement()) {
      if (!sectionHtml || !cart || cart.tagName !== 'CART-DRAWER') return;

      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sourceCartDrawer = parsedHtml.querySelector('cart-drawer');
      const sourceCartDrawerItems = parsedHtml.querySelector('cart-drawer-items');

      if (sourceCartDrawer) {
        cart.classList.toggle('is-empty', sourceCartDrawer.classList.contains('is-empty'));
        return;
      }

      if (sourceCartDrawerItems) {
        cart.classList.toggle('is-empty', sourceCartDrawerItems.classList.contains('is-empty'));
      }
    }

    updateCartUi(sections, cart = this.getCartElement()) {
      if (!sections) return false;

      const sectionsToRender = this.getCartSectionsToRender(cart);

      if (!sectionsToRender.length) {
        if (sections['cart-icon-bubble']) {
          updateCartIconBubble(sections['cart-icon-bubble']);
          return true;
        }

        return false;
      }

      sectionsToRender.forEach((section) => {
        const sectionId = section.section || section.id;
        const sectionHtml = sections[sectionId] || sections[section.id];
        if (!sectionHtml) return;

        if (sectionId === 'cart-drawer') {
          this.syncCartDrawerState(sectionHtml, cart);
        }

        if (section.id === 'cart-icon-bubble') {
          updateCartIconBubble(sectionHtml, section.selector || '.shopify-section');
          return;
        }

        const sectionRoot = document.getElementById(section.id);
        const sectionElement =
          sectionRoot && section.selector ? sectionRoot.querySelector(section.selector) || sectionRoot : sectionRoot;
        const targetElement = sectionElement || (section.selector ? document.querySelector(section.selector) : null);
        if (!targetElement) return;

        targetElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      return true;
    }

    async refreshCartUi(parsedState = null) {
      const cart = this.getCartElement();

      if (parsedState?.sections && this.updateCartUi(parsedState.sections, cart)) {
        return;
      }

      const sectionUrl = new URL(window.location.href);
      const sectionIds = this.getCartSectionsToRender(cart)
        .map((section) => section.section || section.id)
        .filter(Boolean);

      if (!sectionIds.length) {
        sectionIds.push('cart-icon-bubble');
      }

      sectionUrl.searchParams.set('sections', [...new Set(sectionIds)].join(','));
      sectionUrl.searchParams.delete('section_id');

      const response = await fetch(sectionUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const sections = await response.json();

      this.updateCartUi(sections, cart);
    }

    updateCartBubbleCount(itemCount) {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const countElement = bubble.querySelector('[aria-hidden="true"]');
        if (countElement) countElement.textContent = itemCount;

        if (itemCount > 0) {
          bubble.removeAttribute('hidden');
        } else {
          bubble.setAttribute('hidden', 'hidden');
        }
      });
    }

    async fetchCartState() {
      const response = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    }

    normalizeLineItemProperties(properties) {
      if (!properties || typeof properties !== 'object') return {};

      return Object.entries(properties).reduce((normalizedProperties, [key, value]) => {
        if (value === undefined || value === null || value === '') return normalizedProperties;

        normalizedProperties[key] = `${value}`;
        return normalizedProperties;
      }, {});
    }

    propertiesMatch(lineItemProperties, expectedProperties) {
      const normalizedLineItemProperties = this.normalizeLineItemProperties(lineItemProperties);
      const normalizedExpectedProperties = this.normalizeLineItemProperties(expectedProperties);
      const lineItemKeys = Object.keys(normalizedLineItemProperties).sort();
      const expectedKeys = Object.keys(normalizedExpectedProperties).sort();

      if (lineItemKeys.length !== expectedKeys.length) return false;

      return expectedKeys.every(
        (key, index) => lineItemKeys[index] === key && normalizedLineItemProperties[key] === normalizedExpectedProperties[key]
      );
    }

    findCartLineForCard(card, cartState) {
      const variantId = Number.parseInt(card?.dataset.variantId || '', 10);
      if (!Number.isFinite(variantId) || !Array.isArray(cartState?.items)) return null;

      const expectedProperties = this.getAgentLineItemProperties() || {};

      return cartState.items.find(
        (item) => item.variant_id === variantId && this.propertiesMatch(item.properties, expectedProperties)
      ) || null;
    }

    getCardQuantity(card) {
      const quantity = Number.parseInt(card?.dataset.cartQuantity || '', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
    }

    updateCardQuantityUi(card, quantity) {
      if (!card) return;

      const buttonGroup = card.querySelector('[data-cart-button-group]');
      const quantityActions = card.querySelector('[data-cart-quantity-actions]');
      const quantityNode = card.querySelector('[data-cart-quantity]');
      const buyButton = card.querySelector('[data-product-action="buy-now"]');
      const addButton = card.querySelector('[data-product-action="add-to-cart"]');
      const incrementButton = card.querySelector('[data-product-action="increment-cart-quantity"]');
      const decrementButton = card.querySelector('[data-product-action="decrement-cart-quantity"]');
      const isAvailable = card.dataset.variantAvailable === 'true';
      const isUpdating = card.dataset.cartUpdating === 'true';

      card.dataset.cartQuantity = `${quantity}`;

      if (quantityNode) {
        quantityNode.textContent = `${quantity}`;
      }

      if (buttonGroup) {
        buttonGroup.hidden = quantity > 0;
      }

      if (quantityActions) {
        quantityActions.hidden = quantity <= 0;
      }

      if (buyButton) {
        buyButton.disabled = isUpdating || !isAvailable;
      }

      if (addButton) {
        addButton.disabled = isUpdating || !isAvailable;
      }

      if (incrementButton) {
        incrementButton.disabled = isUpdating || !isAvailable;
      }

      if (decrementButton) {
        decrementButton.disabled = isUpdating;
      }
    }

    setCardUpdating(card, isUpdating) {
      if (!card) return;

      card.dataset.cartUpdating = isUpdating ? 'true' : 'false';
      this.updateCardQuantityUi(card, this.getCardQuantity(card));
    }

    async syncCardQuantities(cartState = null) {
      let resolvedCartState = cartState;

      if (!resolvedCartState) {
        try {
          resolvedCartState = await this.fetchCartState();
        } catch (error) {
          console.error(error);
          return;
        }
      }

      this.productCards.forEach((card) => {
        const cartLine = this.findCartLineForCard(card, resolvedCartState);
        card.dataset.cartLineKey = cartLine?.key || '';
        this.updateCardQuantityUi(card, cartLine?.quantity || 0);
      });
    }

    isCartStateResponse(payload) {
      return Number.isFinite(payload?.item_count) && Array.isArray(payload?.items);
    }

    async syncCartUiAfterMutation(payload) {
      await this.refreshCartUi(payload);

      const cartState = this.isCartStateResponse(payload) ? payload : await this.fetchCartState();

      this.emitCartUpdated(cartState);
      return cartState;
    }

    async addItemToCart(variantId, triggerElement, quantity = 1) {
      const cart = this.getCartElement();
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      };

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', `${quantity}`);

      const agentLineItemProperties = this.getAgentLineItemProperties();
      if (agentLineItemProperties) {
        Object.entries(agentLineItemProperties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
      }

      const sectionsToRender = this.getCartSectionsToRender(cart);
      if (sectionsToRender.length) {
        formData.append('sections', sectionsToRender.map((section) => section.section || section.id).join(','));
        formData.append('sections_url', this.getSectionsUrl());
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(triggerElement);
      }

      config.body = formData;

      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config);
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Add failed');

      return data;
    }

    async updateCartLineQuantity(lineKey, quantity, triggerElement) {
      const cart = this.getCartElement();
      const sectionsToRender = this.getCartSectionsToRender(cart);
      const payload = {
        id: lineKey,
        quantity,
      };

      if (sectionsToRender.length) {
        payload.sections = sectionsToRender.map((section) => section.section || section.id);
        payload.sections_url = this.getSectionsUrl();
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(triggerElement);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Cart update failed');
      }

      return data;
    }

    async changeCardQuantity(card, nextQuantity, triggerElement) {
      if (!card) return false;

      const variantId = card.dataset.variantId;
      if (!variantId) return false;

      this.setCardUpdating(card, true);

      try {
        let responsePayload;
        const currentQuantity = this.getCardQuantity(card);
        const lineKey = card.dataset.cartLineKey || '';

        if (nextQuantity <= 0) {
          if (!lineKey) {
            await this.syncCardQuantities();
            return false;
          }

          responsePayload = await this.updateCartLineQuantity(lineKey, 0, triggerElement);
        } else if (currentQuantity <= 0 || !lineKey) {
          responsePayload = await this.addItemToCart(variantId, triggerElement, 1);
        } else {
          responsePayload = await this.updateCartLineQuantity(lineKey, nextQuantity, triggerElement);
        }

        await this.syncCartUiAfterMutation(responsePayload);
        return true;
      } catch (error) {
        console.error(error);
        await this.syncCardQuantities();
        return false;
      } finally {
        this.setCardUpdating(card, false);
      }
    }

    handleActionClick(event) {
      const button = event.target.closest('[data-product-action]');
      if (!button) return;

      event.preventDefault();

      const card = button.closest('[data-best-seller-card]');
      if (!card) return;

      const action = button.dataset.productAction;
      if (action === 'increment-cart-quantity') {
        this.changeCardQuantity(card, this.getCardQuantity(card) + 1, button);
        return;
      }

      if (action === 'decrement-cart-quantity') {
        this.changeCardQuantity(card, this.getCardQuantity(card) - 1, button);
        return;
      }

      const variantId = button.dataset.variantId || card.dataset.variantId;
      if (!variantId) return;

      if (action === 'buy-now') {
        this.buyNow(variantId, button);
      }

      if (action === 'add-to-cart') {
        this.addToCart(variantId, button);
      }
    }

    getCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    getCartSectionsToRender(cart = this.getCartElement()) {
      if (!cart) return [];

      if (cart.tagName === 'CART-DRAWER') {
        const cartItems = cart.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          return cartItems.getSectionsToRender();
        }
      }

      if (typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender();
      }

      return [];
    }

    async refreshCartBubble() {
      const cart = await this.fetchCartState();
      this.updateCartBubbleCount(cart.item_count);
      return cart;
    }

    async addToCart(variantId, button) {
      const card = button.closest('[data-best-seller-card]');
      await this.changeCardQuantity(card, this.getCardQuantity(card) + 1, button);
    }

    async buyNow(variantId, button) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading...';

      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        const cartItem = { id: variantId, quantity: 1 };
        const agentLineItemProperties = this.getAgentLineItemProperties();
        if (agentLineItemProperties) {
          cartItem.properties = agentLineItemProperties;
        }

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [cartItem],
          }),
        });

        if (!addResponse.ok) throw new Error('Add failed');
        window.location.href = '/checkout';
      } catch (error) {
        button.textContent = originalText;
        button.disabled = false;
        console.error(error);
      }
    }
  }

  if (!customElements.get('best-sellers-slider')) {
    customElements.define('best-sellers-slider', BestSellersSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mixed-catalog-grid"] && !Shopify.designMode) return;
  try {
    
  class MixedCatalogGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.grid = this.querySelector('.mixed-catalog__grid');
      this.shell = this.querySelector('.mixed-catalog__shell');
      this.layout = this.querySelector('.mixed-catalog__layout');
      this.items = Array.from(this.querySelectorAll('[data-item-card]'));
      this.productCards = Array.from(this.querySelectorAll('[data-cart-product-card]'));
      this.bundleProductCards = Array.from(this.querySelectorAll('[data-bundle-product-card]'));
      this.filterButtons = Array.from(this.querySelectorAll('[data-filter-button]'));
      this.clearButton = this.querySelector('[data-clear-filters]');
      this.visibleCount = this.querySelector('[data-visible-count]');
      this.emptyState = this.querySelector('[data-empty-state]');
      this.pagination = this.querySelector('[data-pagination]');
      this.paginationStatus = this.querySelector('[data-pagination-status]');
      this.loadMoreButton = this.querySelector('[data-load-more]');
      this.mobileFilterState = this.querySelector('[data-mobile-filter-state]');
      this.filtersColumn = this.querySelector('.mixed-catalog__filters-column');
      this.filtersSticky = this.querySelector('.mixed-catalog__filters-sticky');
      this.filtersPanel = this.querySelector('.mixed-catalog__filters');
      this.filterAccordions = Array.from(this.querySelectorAll('.mixed-catalog__filters-panel .mixed-catalog__accordion-item'));
      this.bundleBuilderEnabled = this.dataset.bundleBuilderEnabled === 'true';
      this.bundleBuilderMoq = Number.parseInt(this.dataset.bundleBuilderMoq, 10) || 15;
      this.bundleBuilderToggleButtons = Array.from(this.querySelectorAll('[data-bundle-builder-toggle]'));
      this.bundleBuilderToggleLabels = Array.from(this.querySelectorAll('[data-bundle-builder-toggle-label]'));
      this.viewPrebuiltBundleButtons = Array.from(this.querySelectorAll('[data-view-prebuilt-bundles]'));
      this.bundleLaunchCount = this.querySelector('[data-bundle-launch-count]');
      this.bundleTray = this.querySelector('[data-bundle-tray]');
      this.bundleSlotsWrap = this.querySelector('[data-bundle-slots-wrap]');
      this.bundleSlots = this.querySelector('[data-bundle-slots]');
      this.bundleScrollButtons = Array.from(this.querySelectorAll('[data-bundle-scroll-direction]'));
      this.bundleStatus = this.querySelector('[data-bundle-status]');
      this.bundleQuantityLabel = this.querySelector('[data-bundle-quantity-label]');
      this.bundleCheckoutButton = this.querySelector('[data-bundle-checkout]');
      this.bundleCheckoutCount = this.querySelector('[data-bundle-checkout-count]');
      this.bundleCheckoutLabel = this.querySelector('[data-bundle-checkout-label]');
      const parsedPaginationStep = Number.parseInt(this.dataset.paginationStep, 10);
      this.paginationStep = Number.isFinite(parsedPaginationStep) && parsedPaginationStep > 0 ? parsedPaginationStep : 10;
      this.paginationLimit = this.paginationStep;
      this.defaultFilter = this.dataset.defaultFilter || 'all';
      this.activeFilters = {
        scents: null,
        inspired: null,
        browse: null,
      };
      this.agentOrigin = this.dataset.agentOrigin || '';
      const parsedAgentShopMoq = Number.parseInt(this.dataset.agentShopMoq, 10);
      this.agentShopMoq = Number.isFinite(parsedAgentShopMoq) && parsedAgentShopMoq > 0 ? parsedAgentShopMoq : null;
      const parsedAgentShopDiscount = Number.parseInt(this.dataset.agentShopDiscount, 10);
      this.agentShopDiscount = Number.isFinite(parsedAgentShopDiscount) && parsedAgentShopDiscount > 0 ? parsedAgentShopDiscount : null;
      this.cartNotice = null;
      this.cartNoticeTimer = null;
      this.bundleBuilderItems = new Map();
      this.bundleBuilderSequence = 0;
      this.bundleBuilderOpen = false;
      this.bundleBuilderStateInitialized = false;
      this.bundleCheckoutPending = false;
      this.urlForcedBundles = false;
      this.bundleTrayHideTimer = null;
      this.mobileBundleTrayScrollThreshold = 500;
      this.lastScrollY = window.scrollY;
      this.isScrollingUp = false;
      this.wasMobileViewport = window.innerWidth <= 989;
      this.mobileFiltersInitialized = false;

      this.syncMobileFilters = this.syncMobileFilters.bind(this);
      this.syncMobileFixedFilters = this.syncMobileFixedFilters.bind(this);
      this.syncDesktopFixedFilters = this.syncDesktopFixedFilters.bind(this);
      this.handleFiltersPanelToggle = this.syncMobileFixedFilters.bind(this);
      this.handleWindowScroll = this.handleWindowScroll.bind(this);
      this.handleFilterAccordionToggle = this.handleAccordionToggle.bind(this);
      this.handleBundleSlotScroll = this.updateBundleScrollControls.bind(this);
      this.handleBundleBuilderStateChange = this.handleBundleBuilderStateChange.bind(this);
      this.handleCartUpdated = this.handleCartUpdated.bind(this);

      this.bundleBuilderStore = this.getBundleBuilderStore();
      if (this.bundleBuilderEnabled && this.bundleBuilderStore && typeof this.bundleBuilderStore.subscribe === 'function') {
        this.bundleBuilderUnsubscribe = this.bundleBuilderStore.subscribe(this.handleBundleBuilderStateChange);
      }

      this.formatMoneyValues();
      this.syncAccordionState();
      this.updateBundleBuilderToggleButton();
      this.updateFilterCounts();
      this.initializeDefaultFilter();
      this.updateBundleBuilderUi();
      this.bindEvents();
      this.applyFilters();
      this.syncCardQuantities();
      this.syncMobileFilters();
      this.syncMobileFixedFilters();
      this.syncDesktopFixedFilters();
      this.updateBundleTrayVisibility();

      document.addEventListener('superior:cart-updated', this.handleCartUpdated);
      window.addEventListener('resize', this.syncMobileFilters);
      window.addEventListener('scroll', this.handleWindowScroll, { passive: true });

      this._headerEl = document.querySelector('.section-header');
      if (this._headerEl) {
        this._handleHeaderTransition = () => {
          this.syncMobileFixedFilters();
          this.syncDesktopFixedFilters();
        };
        this._headerEl.addEventListener('transitionend', this._handleHeaderTransition);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('superior:cart-updated', this.handleCartUpdated);
      window.removeEventListener('resize', this.syncMobileFilters);
      window.removeEventListener('scroll', this.handleWindowScroll);

      if (this._headerEl && this._handleHeaderTransition) {
        this._headerEl.removeEventListener('transitionend', this._handleHeaderTransition);
      }

      if (this.bundleBuilderUnsubscribe) {
        this.bundleBuilderUnsubscribe();
      }

      if (this.cartNoticeTimer) {
        clearTimeout(this.cartNoticeTimer);
      }

      if (this.bundleTrayHideTimer) {
        clearTimeout(this.bundleTrayHideTimer);
      }

      if (this.bundleSlots) {
        this.bundleSlots.removeEventListener('scroll', this.handleBundleSlotScroll);
      }

      this.filterAccordions.forEach((accordion) => {
        accordion.removeEventListener('toggle', this.handleFilterAccordionToggle);
      });

      if (this.filtersPanel) {
        this.filtersPanel.removeEventListener('toggle', this.handleFiltersPanelToggle);
      }

      if (this.cartNotice) {
        this.cartNotice.remove();
        this.cartNotice = null;
      }
    }

    syncMobileFilters() {
      if (!this.filtersPanel) return;

      const isMobileViewport = window.innerWidth <= 989;
      const enteredMobileViewport = !this.wasMobileViewport && isMobileViewport;

      if (isMobileViewport) {
        if (!this.mobileFiltersInitialized || enteredMobileViewport) {
          this.filtersPanel.open = false;
          this.mobileFiltersInitialized = true;
        }

        this.syncMobileFixedFilters();
      } else {
        this.filtersPanel.open = true;
        this.clearMobileFixedFilters();
      }

      this.wasMobileViewport = isMobileViewport;

      this.syncDesktopFixedFilters();
      this.updateBundleTrayVisibility();
      this.updateBundleScrollControls();
    }

    closeMobileFilters() {
      if (!this.filtersPanel || window.innerWidth > 989) return;

      this.filtersPanel.open = false;
    }

    getBundleBuilderStore() {
      return window.SuperiorMixAndMatch || null;
    }

    getBundleBuilderContext() {
      if (!this.agentOrigin) return null;

      return {
        origin: this.agentOrigin,
        moq: this.agentShopMoq,
        discount: this.agentShopDiscount,
      };
    }

    handleBundleBuilderStateChange(state) {
      if (!this.bundleBuilderEnabled || !state) return;

      const previousOpenState = this.bundleBuilderOpen;
      const nextContext = state.agentContext || null;
      const parsedStateMoq = Number.parseInt(state.effectiveMoq, 10);
      const parsedAgentMoq = Number.parseInt(nextContext?.moq, 10);
      const parsedAgentDiscount = Number.parseFloat(nextContext?.discount);

      this.bundleBuilderOpen = Boolean(state.open);
      this.bundleCheckoutPending = Boolean(state.checkoutPending);
      this.bundleBuilderItems = new Map((state.items || []).map((item) => [String(item.id), { ...item }]));
      this.classList.remove('is-bundle-builder-open');

      if (nextContext?.origin) {
        this.agentOrigin = nextContext.origin;
      }

      if (Number.isFinite(parsedAgentMoq) && parsedAgentMoq > 0) {
        this.agentShopMoq = parsedAgentMoq;
      }

      if (Number.isFinite(parsedAgentDiscount) && parsedAgentDiscount > 0) {
        this.agentShopDiscount = parsedAgentDiscount;
      }

      if (Number.isFinite(parsedStateMoq) && parsedStateMoq > 0) {
        this.bundleBuilderMoq = parsedStateMoq;
      }

      this.updateBundleBuilderToggleButton();
      this.updateBundleBuilderUi();

      const shouldRefreshFilters = !this.bundleBuilderStateInitialized || previousOpenState !== this.bundleBuilderOpen;
      this.bundleBuilderStateInitialized = true;

      if (!shouldRefreshFilters) return;

      if (this.urlForcedBundles) {
        if (this.bundleBuilderOpen) {
          this.toggleBundleBuilder(false);
        }
        this.setActiveFilter('browse', 'bundles');
      } else if (this.bundleBuilderOpen && this.getActiveFilter('browse') === 'bundles') {
        this.setActiveFilter('browse', null);
      } else if (!this.bundleBuilderOpen) {
        this.initializeDefaultFilter();
      }

      this.resetPagination();
      this.updateFilterCounts();
      this.applyFilters();
    }

    getVisibleHeaderBottom() {
      let bottom = 0;
      document.querySelectorAll(
        '.section-header.shopify-section-group-header-group, .shopify-section-header-sticky'
      ).forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) bottom = Math.max(bottom, r.bottom);
      });
      return bottom;
    }

    getMobileFixedTopOffset() {
      const headerBottom = this.getVisibleHeaderBottom();
      if (this.isScrollingUp) {
        const fullHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        return Math.max(headerBottom, fullHeight) + 8;
      }
      return headerBottom + 8;
    }

    clearMobileFixedFilters() {
      if (!this.filtersSticky || !this.filtersColumn) return;

      this.filtersSticky.classList.remove('is-mobile-fixed');
      this.filtersColumn.classList.remove('is-mobile-filter-fixed');
      this.filtersColumn.style.removeProperty('--mc-mobile-fixed-height');
      this.filtersSticky.style.removeProperty('left');
      this.filtersSticky.style.removeProperty('top');
      this.filtersSticky.style.removeProperty('width');
      this.filtersSticky.style.removeProperty('min-width');
      this.filtersSticky.style.removeProperty('max-width');
    }

    syncMobileFixedFilters() {
      if (!this.filtersSticky || !this.filtersColumn) return;

      if (window.innerWidth > 989) {
        this.clearMobileFixedFilters();
        return;
      }

      if (this.isScrollingUp && window.scrollY < 120) {
        this.clearMobileFixedFilters();
        return;
      }

      const shellElement = this.shell || this;
      const sectionRect = shellElement.getBoundingClientRect();
      const columnRect = this.filtersColumn.getBoundingClientRect();
      const stickyHeight = this.filtersSticky.offsetHeight;
      const topOffset = this.getMobileFixedTopOffset();
      const triggerOffset = Math.max(window.innerHeight * 0.1, topOffset);
      const shellStyles = window.getComputedStyle(shellElement);
      const shellPaddingLeft = Number.parseFloat(shellStyles.paddingLeft) || 0;
      const shellPaddingRight = Number.parseFloat(shellStyles.paddingRight) || 0;
      const isCurrentlyPinned = this.filtersSticky.classList.contains('is-mobile-fixed');
      const hasReachedStickyZone = isCurrentlyPinned && this.isScrollingUp
        ? columnRect.top < topOffset + 16
        : columnRect.top <= triggerOffset;

      if (!hasReachedStickyZone) {
        this.clearMobileFixedFilters();
        return;
      }

      this.filtersColumn.classList.add('is-mobile-filter-fixed');
      this.filtersSticky.classList.add('is-mobile-fixed');
      this.filtersColumn.style.setProperty('--mc-mobile-fixed-height', `${stickyHeight}px`);
      const fixedLeft = sectionRect.left + shellPaddingLeft;
      const fixedWidth = Math.max(sectionRect.width - shellPaddingLeft - shellPaddingRight, 0);
      const fixedWidthValue = `${fixedWidth}px`;
      this.filtersSticky.style.left = `${fixedLeft}px`;
      this.filtersSticky.style.top = `${topOffset}px`;
      this.filtersSticky.style.width = fixedWidthValue;
      this.filtersSticky.style.minWidth = fixedWidthValue;
      this.filtersSticky.style.maxWidth = fixedWidthValue;
    }

    getDesktopFixedTopOffset() {
      const rootFontSize = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
      return this.getVisibleHeaderBottom() + rootFontSize * 2;
    }

    clearDesktopFixedFilters() {
      if (!this.filtersSticky || !this.filtersColumn) return;

      this.filtersSticky.classList.remove('is-desktop-fixed', 'is-desktop-stuck-bottom');
      this.filtersColumn.classList.remove('is-desktop-filter-fixed');
      this.filtersColumn.style.removeProperty('--mc-desktop-fixed-height');
      this.filtersSticky.style.removeProperty('left');
      this.filtersSticky.style.removeProperty('top');
      this.filtersSticky.style.removeProperty('width');
      this.filtersSticky.style.removeProperty('min-width');
      this.filtersSticky.style.removeProperty('max-width');
    }

    syncDesktopFixedFilters() {
      if (!this.filtersSticky || !this.filtersColumn) return;

      if (window.innerWidth <= 989) {
        this.clearDesktopFixedFilters();
        return;
      }

      const columnRect = this.filtersColumn.getBoundingClientRect();
      const boundaryRect = (this.layout || this.shell || this).getBoundingClientRect();
      const stickyHeight = this.filtersSticky.offsetHeight;
      const topOffset = this.getDesktopFixedTopOffset();
      const shouldFix = columnRect.top <= topOffset;
      const shouldStickBottom = boundaryRect.bottom <= topOffset + stickyHeight;

      this.clearDesktopFixedFilters();

      if (!shouldFix) return;

      if (shouldStickBottom) {
        this.filtersSticky.classList.add('is-desktop-stuck-bottom');
        return;
      }

      this.filtersColumn.classList.add('is-desktop-filter-fixed');
      this.filtersColumn.style.setProperty('--mc-desktop-fixed-height', `${stickyHeight}px`);
      this.filtersSticky.classList.add('is-desktop-fixed');
      const fixedWidth = this.filtersColumn.offsetWidth || columnRect.width;
      const fixedWidthValue = `${fixedWidth}px`;
      this.filtersSticky.style.left = `${columnRect.left}px`;
      this.filtersSticky.style.top = `${topOffset}px`;
      this.filtersSticky.style.width = fixedWidthValue;
      this.filtersSticky.style.minWidth = fixedWidthValue;
      this.filtersSticky.style.maxWidth = fixedWidthValue;
    }

    handleWindowScroll() {
      const currentY = window.scrollY;
      this.isScrollingUp = currentY < this.lastScrollY;
      this.lastScrollY = currentY;

      this.syncMobileFixedFilters();
      this.syncDesktopFixedFilters();
      this.updateBundleTrayVisibility();

      if (this.isScrollingUp && window.innerWidth <= 989) {
        this._chaseHeaderPosition();
      }
    }

    _chaseHeaderPosition() {
      if (this._chaseRaf) return;
      let frames = 0;
      const chase = () => {
        this.syncMobileFixedFilters();
        frames++;
        if (frames < 12) {
          this._chaseRaf = requestAnimationFrame(chase);
        } else {
          this._chaseRaf = null;
        }
      };
      this._chaseRaf = requestAnimationFrame(chase);
    }

    shouldHideBundleTrayForMobileScroll() {
      return false;
    }

    updateBundleTrayVisibility() {
      if (!this.bundleTray || !this.bundleBuilderEnabled) return;

      const shouldHideForMobileScroll = this.bundleBuilderOpen && this.shouldHideBundleTrayForMobileScroll();
      this.bundleTray.classList.toggle('is-mobile-scroll-hidden', shouldHideForMobileScroll);
    }

    bindEvents() {
      if (this.filtersPanel) {
        this.filtersPanel.addEventListener('toggle', this.handleFiltersPanelToggle);
      }

      this.filterAccordions.forEach((accordion) => {
        accordion.addEventListener('toggle', this.handleFilterAccordionToggle);
      });

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.filter;
          const group = button.dataset.filterGroup;
          if (!filter || !group || button.disabled) return;

          if (group === 'show') {
            this.clearActiveFilters();
          } else if (group === 'scents') {
            if (filter === 'all-scents' || this.getActiveFilter('scents') === filter) {
              this.setActiveFilter('scents', null);
            } else {
              this.setActiveFilter('scents', filter);
            }
          } else if (group === 'inspired') {
            if (filter === 'all-inspired' || this.getActiveFilter('inspired') === filter) {
              this.setActiveFilter('inspired', null);
            } else {
              this.setActiveFilter('inspired', filter);
            }
          } else if (group === 'browse') {
            if (this.getActiveFilter('browse') === filter) {
              this.setActiveFilter('browse', null);
            } else {
              this.setActiveFilter('browse', filter);
            }
          } else {
            return;
          }

          this.resetPagination();
          this.applyFilters();
          this.closeMobileFilters();
        });
      });

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => {
          this.showMoreItems();
        });
      }

      if (this.bundleBuilderEnabled && this.bundleBuilderToggleButtons.length) {
        this.bundleBuilderToggleButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.toggleBundleBuilder();
          });
        });
      }

      if (this.viewPrebuiltBundleButtons.length) {
        this.viewPrebuiltBundleButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.showPrebuiltBundles();
          });
        });
      }

      if (this.bundleBuilderEnabled && this.bundleSlots) {
        this.bundleSlots.addEventListener('scroll', this.handleBundleSlotScroll, { passive: true });
      }

      if (this.bundleBuilderEnabled && this.bundleScrollButtons.length) {
        this.bundleScrollButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const direction = Number.parseInt(button.dataset.bundleScrollDirection, 10) || 0;
            this.scrollBundleSlots(direction);
          });
        });
      }

      if (this.clearButton) {
        this.clearButton.addEventListener('click', () => {
          this.clearActiveFilters();
          this.resetPagination();
          this.applyFilters();
          this.closeMobileFilters();
        });
      }

      this.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-bundle-item]');
        if (removeButton) {
          event.preventDefault();
          this.removeBundleItem(removeButton.dataset.removeBundleItem);
          return;
        }

        const actionButton = event.target.closest('[data-product-action]');
        if (!actionButton) return;

        event.preventDefault();

        const action = actionButton.dataset.productAction;
        if (!action) return;

        if (
          this.bundleBuilderEnabled &&
          ['add-to-bundle', 'increment-bundle-item', 'decrement-bundle-item', 'checkout-bundle'].includes(action)
        ) {
          this.handleBundleBuilderAction(actionButton, action);
          return;
        }

        const cartCard = actionButton.closest('[data-cart-product-card]');
        if (cartCard && action === 'increment-cart-quantity') {
          this.changeCardQuantity(cartCard, this.getCardQuantity(cartCard) + 1, actionButton);
          return;
        }

        if (cartCard && action === 'decrement-cart-quantity') {
          this.changeCardQuantity(cartCard, this.getCardQuantity(cartCard) - 1, actionButton);
          return;
        }

        const bundleItems = this.getBundleItems(actionButton);
        if (bundleItems.length) {
          if (action === 'buy-now') {
            this.buyBundleNow(bundleItems, actionButton);
          }

          if (action === 'add-to-cart') {
            this.addBundleToCart(bundleItems, actionButton);
          }

          return;
        }

        const variantId = actionButton.dataset.variantId;
        if (!variantId) return;

        if (action === 'buy-now') {
          this.buyNow(variantId, actionButton);
        }

        if (action === 'add-to-cart') {
          this.addToCart(variantId, actionButton);
        }
      });
    }

    syncAccordionState() {
      if (!this.filterAccordions.length) return;

      let hasOpenAccordion = false;

      this.filterAccordions.forEach((accordion) => {
        if (!accordion.open) return;

        if (!hasOpenAccordion) {
          hasOpenAccordion = true;
          return;
        }

        accordion.open = false;
      });
    }

    handleAccordionToggle(event) {
      const toggledAccordion = event.currentTarget;
      if (!toggledAccordion?.open) return;

      this.filterAccordions.forEach((accordion) => {
        if (accordion !== toggledAccordion && accordion.open) {
          accordion.open = false;
        }
      });
    }

    updateBundleBuilderToggleButton() {
      if (!this.bundleBuilderToggleButtons.length) return;

      const toggleLabel = this.bundleBuilderOpen ? 'Close Mix & Match' : 'Mix & Match your own bundle';

      this.bundleBuilderToggleLabels.forEach((label) => {
        label.textContent = toggleLabel;
      });

      this.bundleBuilderToggleButtons.forEach((button) => {
        button.setAttribute('aria-pressed', this.bundleBuilderOpen ? 'true' : 'false');
        button.setAttribute('aria-expanded', this.bundleBuilderOpen ? 'true' : 'false');
        button.setAttribute('aria-label', toggleLabel);
      });
    }

    isHiddenByBundleBuilder(item) {
      return this.bundleBuilderEnabled && this.bundleBuilderOpen && item.hasAttribute('data-bundle-card');
    }

    handleBundleBuilderAction(actionButton, action) {
      if (action === 'checkout-bundle') {
        this.checkoutBundleBuilder(actionButton);
        return;
      }

      const productData = this.getBundleProductData(actionButton.closest('[data-bundle-product-card]'));
      if (!productData?.id) return;

      const currentQuantity = this.getBundleItemQuantity(productData.id);

      if (action === 'add-to-bundle' || action === 'increment-bundle-item') {
        this.setBundleItemQuantity(productData.id, currentQuantity + 1, productData);
        this.toggleBundleBuilder(true);
        this.animateItemToBundle(actionButton.closest('[data-bundle-product-card]'), productData.id);
        return;
      }

      if (action === 'decrement-bundle-item') {
        this.setBundleItemQuantity(productData.id, currentQuantity - 1, productData);
      }
    }

    toggleBundleBuilder(forceState = null) {
      if (!this.bundleBuilderEnabled) return;

      const store = this.getBundleBuilderStore();
      if (!store) return;

      const nextState = typeof forceState === 'boolean' ? forceState : !this.bundleBuilderOpen;

      if (!nextState) {
        if (typeof store.toggleOpen === 'function') {
          store.toggleOpen(false, this.getBundleBuilderContext());
        }

        return;
      }

      if (typeof store.toggleOpen === 'function') {
        store.toggleOpen(true, this.getBundleBuilderContext());
      }
    }

    showPrebuiltBundles() {
      if (this.bundleBuilderEnabled && this.bundleBuilderOpen) {
        this.toggleBundleBuilder(false);
      }

      this.setActiveFilter('scents', null);
      this.setActiveFilter('inspired', null);
      this.setActiveFilter('browse', 'bundles');
      this.resetPagination();
      this.updateFilterCounts();
      this.applyFilters();
      this.closeMobileFilters();
    }

    clearActiveFilters() {
      this.activeFilters.scents = null;
      this.activeFilters.inspired = null;
      this.activeFilters.browse = null;
    }

    setActiveFilter(group, filter) {
      if (!Object.prototype.hasOwnProperty.call(this.activeFilters, group)) return;

      this.activeFilters[group] = filter || null;
    }

    getActiveFilter(group) {
      if (!Object.prototype.hasOwnProperty.call(this.activeFilters, group)) return null;

      return this.activeFilters[group] || null;
    }

    hasActiveFilters() {
      return Object.values(this.activeFilters).some(Boolean);
    }

    isFilterButtonActive(button) {
      const filter = button.dataset.filter;
      const group = button.dataset.filterGroup;

      if (group === 'show') {
        return !this.hasActiveFilters();
      }

      if (group === 'scents') {
        if (filter === 'all-scents') {
          return !this.getActiveFilter('scents');
        }

        return this.getActiveFilter('scents') === filter;
      }

      if (group === 'inspired') {
        if (filter === 'all-inspired') {
          return !this.getActiveFilter('inspired');
        }

        return this.getActiveFilter('inspired') === filter;
      }

      if (group === 'browse') {
        return this.getActiveFilter('browse') === filter;
      }

      return false;
    }

    matchesItemAgainstFilters(item, overrides = {}) {
      if (!item || this.isHiddenByBundleBuilder(item)) return false;

      const itemFilters = this.getItemFilters(item);
      const scentFilter = Object.prototype.hasOwnProperty.call(overrides, 'scents')
        ? overrides.scents
        : this.getActiveFilter('scents');
      const inspiredFilter = Object.prototype.hasOwnProperty.call(overrides, 'inspired')
        ? overrides.inspired
        : this.getActiveFilter('inspired');
      const browseFilter = Object.prototype.hasOwnProperty.call(overrides, 'browse')
        ? overrides.browse
        : this.getActiveFilter('browse');

      if (scentFilter && !itemFilters.includes(scentFilter)) {
        return false;
      }

      if (inspiredFilter && !itemFilters.includes(inspiredFilter)) {
        return false;
      }

      if (browseFilter && !itemFilters.includes(browseFilter)) {
        return false;
      }

      return true;
    }

    getFilterCountForButton(filterableItems, button) {
      const filter = button.dataset.filter;
      const group = button.dataset.filterGroup;

      if (group === 'show') {
        return filterableItems.length;
      }

      if (group === 'scents') {
        const scentFilter = filter === 'all-scents' ? null : filter;

        return filterableItems.reduce((count, item) => {
          return count + (this.matchesItemAgainstFilters(item, { scents: scentFilter }) ? 1 : 0);
        }, 0);
      }

      if (group === 'inspired') {
        const inspiredFilter = filter === 'all-inspired' ? null : filter;

        return filterableItems.reduce((count, item) => {
          return count + (this.matchesItemAgainstFilters(item, { inspired: inspiredFilter }) ? 1 : 0);
        }, 0);
      }

      if (group === 'browse') {
        return filterableItems.reduce((count, item) => {
          return count + (this.matchesItemAgainstFilters(item, { browse: filter }) ? 1 : 0);
        }, 0);
      }

      return 0;
    }

    getFilterLabel(group, filter) {
      if (!group || !filter) return '';

      const button = this.filterButtons.find((candidate) => {
        return candidate.dataset.filterGroup === group && candidate.dataset.filter === filter;
      });

      return button?.querySelector('span')?.textContent?.trim() || '';
    }

    updateFilterCounts() {
      const filterableItems = this.items.filter((item) => !this.isHiddenByBundleBuilder(item));

      this.filterButtons.forEach((button) => {
        const filter = button.dataset.filter;
        const group = button.dataset.filterGroup;
        const count = this.getFilterCountForButton(filterableItems, button);
        const countNode = button.querySelector('[data-filter-count]');
        const isActive = this.isFilterButtonActive(button);

        if (countNode) countNode.textContent = count;

        if (group === 'show' || filter === 'all-scents' || filter === 'all-inspired') {
          button.disabled = false;
          button.hidden = false;
          return;
        }

        button.disabled = count === 0 && !isActive;
        button.hidden = count === 0 && !isActive;
      });
    }

    initializeDefaultFilter() {
      this.clearActiveFilters();

      const params = new URLSearchParams(window.location.search);
      const urlView = params.get('view') || params.get('type');
      if (urlView === 'bundles' && this.viewPrebuiltBundleButtons.length) {
        this.urlForcedBundles = true;
        if (this.bundleBuilderOpen) {
          this.toggleBundleBuilder(false);
        }
        this.setActiveFilter('inspired', null);
        this.setActiveFilter('browse', 'bundles');
        this.resetPagination();
        this.updateFilterCounts();
        this.applyFilters();
        this.closeMobileFilters();
        return;
      }

      if (!this.defaultFilter || this.defaultFilter === 'all') return;

      const defaultButton = this.filterButtons.find((button) => {
        return button.dataset.filterGroup === 'browse' && button.dataset.filter === this.defaultFilter;
      });

      if (!defaultButton || defaultButton.disabled || defaultButton.hidden) return;

      this.setActiveFilter('browse', this.defaultFilter);
    }

    resetPagination() {
      this.paginationLimit = this.paginationStep;
    }

    showMoreItems() {
      this.paginationLimit += this.paginationStep;
      this.applyFilters();
    }

    updatePagination(matchedCount, displayedCount) {
      if (!this.pagination || !this.loadMoreButton) return;

      if (this.paginationStatus) {
        this.paginationStatus.textContent = matchedCount > displayedCount
          ? `${displayedCount} of ${matchedCount} items`
          : `${matchedCount} items`;
      }

      const hasMoreItems = matchedCount > displayedCount;
      this.pagination.hidden = !hasMoreItems;

      if (!hasMoreItems) return;

      const remainingCount = matchedCount - displayedCount;
      const loadCount = Math.min(this.paginationStep, remainingCount);
      this.loadMoreButton.setAttribute(
        'aria-label',
        `Load ${loadCount} more ${loadCount === 1 ? 'item' : 'items'}`
      );
    }

    applyFilters() {
      let matchedCount = 0;
      let displayedCount = 0;

      this.sortBundlesFirst();

      this.items.forEach((item) => {
        const matches = this.matchesItemAgainstFilters(item);

        if (!matches) {
          item.classList.add('is-hidden');
          item.classList.remove('is-pagination-hidden');
          return;
        }

        matchedCount += 1;
        const shouldHideForPagination = matchedCount > this.paginationLimit;

        item.classList.remove('is-hidden');
        item.classList.toggle('is-pagination-hidden', shouldHideForPagination);

        if (!shouldHideForPagination) {
          displayedCount += 1;
        }
      });

      this.updateFilterCounts();

      this.filterButtons.forEach((button) => {
        const isActive = this.isFilterButtonActive(button);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.mobileFilterState) {
        const activeLabels = [];
        const scentLabel = this.getFilterLabel('scents', this.getActiveFilter('scents'));
        const inspiredLabel = this.getFilterLabel('inspired', this.getActiveFilter('inspired'));
        const browseLabel = this.getFilterLabel('browse', this.getActiveFilter('browse'));

        if (scentLabel) activeLabels.push(scentLabel);
        if (inspiredLabel) activeLabels.push(inspiredLabel);
        if (browseLabel) activeLabels.push(browseLabel);

        this.mobileFilterState.textContent = activeLabels.join(' + ') || 'All items';
      }

      if (this.visibleCount) {
        this.visibleCount.textContent = matchedCount > displayedCount ? `${displayedCount} of ${matchedCount}` : `${matchedCount}`;
      }
      if (this.emptyState) this.emptyState.hidden = matchedCount !== 0;
      if (this.clearButton) this.clearButton.hidden = !this.hasActiveFilters();
      this.updatePagination(matchedCount, displayedCount);

      this.syncDesktopFixedFilters();
    }

    sortBundlesFirst() {
      const grid = this.grid || this.querySelector('.mixed-catalog__grid');
      if (!grid) return;

      const bundles = [];
      const others = [];

      this.items.forEach((item) => {
        if (item.hasAttribute('data-bundle-card')) {
          bundles.push(item);
        } else {
          others.push(item);
        }
      });

      if (!bundles.length) return;

      bundles.forEach((item) => grid.appendChild(item));
      others.forEach((item) => grid.appendChild(item));

      this.items = Array.from(this.querySelectorAll('[data-item-card]'));
      this.productCards = Array.from(this.querySelectorAll('[data-cart-product-card]'));
    }

    getItemFilters(item) {
      return (item.dataset.filters || '')
        .split('|')
        .map((value) => value.trim())
        .filter(Boolean);
    }

    formatMoneyValues() {
      this.querySelectorAll('[data-money-value]').forEach((node) => {
        const amount = Number.parseFloat(node.dataset.moneyValue);
        if (Number.isNaN(amount)) return;

        node.textContent = amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      });
    }

    getBundleProductData(card) {
      if (!card) return null;

      return {
        id: card.dataset.variantId || '',
        image: card.dataset.bundleImage || '',
        title: card.dataset.bundleTitle || 'Bundle item',
      };
    }

    getBundleBuilderItems() {
      return Array.from(this.bundleBuilderItems.values()).sort((firstItem, secondItem) => firstItem.order - secondItem.order);
    }

    getBundleItemQuantity(variantId) {
      return this.bundleBuilderItems.get(variantId)?.quantity || 0;
    }

    getBundleBuilderTotalQuantity() {
      return this.getBundleBuilderItems().reduce((totalQuantity, item) => totalQuantity + item.quantity, 0);
    }

    setBundleItemQuantity(variantId, quantity, productData = null) {
      if (!variantId) return;

      const store = this.getBundleBuilderStore();
      if (store && typeof store.setItemQuantity === 'function') {
        store.setItemQuantity(variantId, quantity, productData, {
          pageContext: this.getBundleBuilderContext(),
        });
        return;
      }

      const existingItem = this.bundleBuilderItems.get(variantId);

      if (quantity <= 0) {
        this.bundleBuilderItems.delete(variantId);
        this.updateBundleBuilderUi();
        return;
      }

      this.bundleBuilderItems.set(variantId, {
        id: variantId,
        image: productData?.image || existingItem?.image || '',
        order: existingItem?.order ?? this.bundleBuilderSequence++,
        quantity,
        title: productData?.title || existingItem?.title || 'Bundle item',
      });

      this.updateBundleBuilderUi();
    }

    removeBundleItem(variantId) {
      if (!variantId) return;

      const store = this.getBundleBuilderStore();
      if (store && typeof store.removeItem === 'function') {
        store.removeItem(variantId);
        return;
      }

      this.bundleBuilderItems.delete(variantId);
      this.updateBundleBuilderUi();
    }

    updateBundleBuilderUi() {
      if (!this.bundleBuilderEnabled) return;

      const totalQuantity = this.getBundleBuilderTotalQuantity();
      const countLabel = `${totalQuantity}/${this.bundleBuilderMoq}`;
      const isReady = totalQuantity >= this.bundleBuilderMoq;

      if (this.bundleLaunchCount) {
        this.bundleLaunchCount.textContent = countLabel;
      }

      if (this.bundleQuantityLabel) {
        this.bundleQuantityLabel.textContent = countLabel;
      }

      if (this.bundleCheckoutCount) {
        this.bundleCheckoutCount.textContent = countLabel;
      }

      if (this.bundleStatus) {
        this.bundleStatus.textContent = this.formatBundleStatus(totalQuantity);
      }

      if (this.bundleCheckoutButton) {
        this.bundleCheckoutButton.disabled = !isReady || this.bundleCheckoutPending;
        this.bundleCheckoutButton.classList.toggle('is-ready', isReady && !this.bundleCheckoutPending);
      }

      if (this.bundleCheckoutLabel) {
        this.bundleCheckoutLabel.textContent = this.bundleCheckoutPending ? 'Loading...' : 'Checkout bundle';
      }

      this.syncBundleCardControls();
      this.renderBundleSlots();
    }

    syncBundleCardControls() {
      this.bundleProductCards.forEach((card) => {
        const variantId = card.dataset.variantId;
        if (!variantId) return;

        const quantity = this.getBundleItemQuantity(variantId);
        const defaultActions = card.querySelector('[data-default-product-actions]');
        const bundleActions = card.querySelector('[data-bundle-product-actions]');
        const addButton = card.querySelector('[data-add-to-bundle]');
        const stepper = card.querySelector('[data-bundle-stepper]');
        const quantityNode = card.querySelector('[data-bundle-quantity]');
        const bundleModeVisible = this.bundleBuilderOpen;

        if (quantityNode) {
          quantityNode.textContent = `${quantity}`;
        }

        if (defaultActions) {
          defaultActions.hidden = bundleModeVisible;
        }

        if (bundleActions) {
          bundleActions.hidden = !bundleModeVisible;
        }

        if (addButton) {
          addButton.hidden = !bundleModeVisible || quantity > 0;
        }

        if (stepper) {
          stepper.hidden = !bundleModeVisible || quantity === 0;
        }
      });
    }

    scrollBundleSlots(direction) {
      if (!this.bundleSlots || !direction) return;

      const scrollDistance = Math.max(this.bundleSlots.clientWidth * 0.72, 180);

      this.bundleSlots.scrollBy({
        left: direction * scrollDistance,
        behavior: 'smooth',
      });
    }

    updateBundleScrollControls() {
      if (!this.bundleBuilderEnabled || !this.bundleSlots || !this.bundleScrollButtons.length) return;

      const hasOverflow = this.bundleSlots.scrollWidth - this.bundleSlots.clientWidth > 8;
      const canScrollLeft = hasOverflow && this.bundleSlots.scrollLeft > 8;
      const canScrollRight = hasOverflow && this.bundleSlots.scrollLeft + this.bundleSlots.clientWidth < this.bundleSlots.scrollWidth - 8;

      if (this.bundleSlotsWrap) {
        this.bundleSlotsWrap.classList.toggle('can-scroll-left', canScrollLeft);
        this.bundleSlotsWrap.classList.toggle('can-scroll-right', canScrollRight);
      }

      this.bundleScrollButtons.forEach((button) => {
        const direction = Number.parseInt(button.dataset.bundleScrollDirection, 10) || 0;
        button.hidden = !hasOverflow;
        button.disabled = direction < 0 ? !canScrollLeft : !canScrollRight;
      });
    }

    centerOpenBundleSlot(behavior = 'smooth') {
      if (!this.bundleSlots) return;

      const openSlot = this.bundleSlots.querySelector('[data-bundle-slot-empty]');
      if (!openSlot) return;

      const maxScrollLeft = this.bundleSlots.scrollWidth - this.bundleSlots.clientWidth;
      if (maxScrollLeft <= 0) return;

      const slotsRect = this.bundleSlots.getBoundingClientRect();
      const openSlotRect = openSlot.getBoundingClientRect();
      const nextScrollLeft = this.bundleSlots.scrollLeft + (openSlotRect.left + openSlotRect.width / 2) - (slotsRect.left + slotsRect.width / 2);
      const clampedScrollLeft = Math.max(0, Math.min(maxScrollLeft, nextScrollLeft));

      if (behavior === 'auto') {
        this.bundleSlots.scrollLeft = clampedScrollLeft;
        return;
      }

      this.bundleSlots.scrollTo({
        left: clampedScrollLeft,
        behavior,
      });
    }

    renderBundleSlots() {
      if (!this.bundleSlots) return;

      const bundleItems = this.getBundleBuilderItems();
      const emptySlotCount = 1;
      const filledSlots = bundleItems
        .map((item) => {
          const imageMarkup = item.image
            ? `<img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.title)}" loading="lazy" width="120" height="120">`
            : `<div class="mixed-catalog__bundle-slot-placeholder">Item</div>`;

          return `
            <article class="mixed-catalog__bundle-slot mixed-catalog__bundle-slot--filled" data-bundle-slot-variant-id="${this.escapeHtml(item.id)}">
              <button class="mixed-catalog__bundle-slot-remove" type="button" data-remove-bundle-item="${this.escapeHtml(item.id)}" aria-label="Remove ${this.escapeHtml(item.title)} from bundle">&times;</button>
              <div class="mixed-catalog__bundle-slot-media">
                ${imageMarkup}
                <span class="mixed-catalog__bundle-slot-qty">${item.quantity}</span>
              </div>
              <p class="mixed-catalog__bundle-slot-name">${this.escapeHtml(item.title)}</p>
            </article>
          `;
        })
        .join('');

      const emptySlots = Array.from({ length: emptySlotCount }, (_, index) => {
        const slotNumber = bundleItems.length + index + 1;

        return `
          <div class="mixed-catalog__bundle-slot mixed-catalog__bundle-slot--empty" data-bundle-slot-empty>
            <span class="mixed-catalog__bundle-slot-number">${slotNumber}</span>
            <span class="mixed-catalog__bundle-slot-empty-label">Open slot</span>
          </div>
        `;
      }).join('');

      this.bundleSlots.classList.toggle('is-open-slot-centered', bundleItems.length === 0);
      this.bundleSlots.innerHTML = `${filledSlots}${emptySlots}`;

      window.requestAnimationFrame(() => {
        this.centerOpenBundleSlot(bundleItems.length ? 'smooth' : 'auto');
        this.updateBundleScrollControls();
      });
    }

    formatBundleStatus(totalQuantity) {
      if (!totalQuantity) {
        return `Add ${this.bundleBuilderMoq} ${this.bundleBuilderMoq === 1 ? 'item' : 'items'} to complete your bundle`;
      }

      if (totalQuantity < this.bundleBuilderMoq) {
        const remainingQuantity = this.bundleBuilderMoq - totalQuantity;
        return `Add ${remainingQuantity} more ${remainingQuantity === 1 ? 'item' : 'items'} to complete your bundle`;
      }

      if (totalQuantity === this.bundleBuilderMoq) {
        return 'MOQ reached. Your bundle is ready for checkout';
      }

      const extraQuantity = totalQuantity - this.bundleBuilderMoq;
      return `${extraQuantity} extra ${extraQuantity === 1 ? 'item' : 'items'} added above the MOQ`;
    }

    animateItemToBundle(card, variantId) {
      const store = this.getBundleBuilderStore();
      const externalTarget = store && typeof store.getVisualTarget === 'function'
        ? store.getVisualTarget()
        : document.querySelector('[data-mix-match-launcher]');

      if (!card || !variantId || (!this.bundleSlots && !externalTarget) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const sourceElement = card.querySelector('.mixed-catalog__media img') || card.querySelector('.mixed-catalog__media');
      const escapedVariantId = window.CSS?.escape ? window.CSS.escape(String(variantId)) : String(variantId).replace(/"/g, '\\"');
      const builderSlot = document.querySelector(`[data-mix-match-slot-variant-id="${escapedVariantId}"]`);
      const builderEmptySlot = document.querySelector('[data-mix-match-slot-empty]');
      const targetSlot = builderSlot || builderEmptySlot || this.bundleSlots;
      const targetElement = targetSlot?.querySelector?.('.mix-and-match-builder__slot-media, .mixed-catalog__bundle-slot-media') || targetSlot || externalTarget;

      if (!sourceElement || !targetElement) return;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const sourceRect = sourceElement.getBoundingClientRect();
          const targetRect = targetElement.getBoundingClientRect();

          if (!sourceRect.width || !sourceRect.height || !targetRect.width || !targetRect.height) return;

          const clone = sourceElement.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.style.position = 'fixed';
          clone.style.left = `${sourceRect.left}px`;
          clone.style.top = `${sourceRect.top}px`;
          clone.style.width = `${sourceRect.width}px`;
          clone.style.height = `${sourceRect.height}px`;
          clone.style.margin = '0';
          clone.style.objectFit = 'cover';
          clone.style.display = 'block';
          clone.style.overflow = 'hidden';
          clone.style.borderRadius = '1.2rem';
          clone.style.boxShadow = '0 1rem 2rem rgba(0, 0, 0, 0.16)';
          clone.style.transformOrigin = 'center center';
          clone.style.pointerEvents = 'none';
          clone.style.willChange = 'transform, opacity, filter';
          clone.style.filter = 'saturate(1.02)';
          clone.style.zIndex = '42';
          document.body.appendChild(clone);

          const sourceCenterX = sourceRect.left + sourceRect.width / 2;
          const sourceCenterY = sourceRect.top + sourceRect.height / 2;
          const targetCenterX = targetRect.left + targetRect.width / 2;
          const targetCenterY = targetRect.top + targetRect.height / 2;
          const translateX = targetCenterX - sourceCenterX;
          const translateY = targetCenterY - sourceCenterY;
          const scaleX = targetRect.width / sourceRect.width;
          const scaleY = targetRect.height / sourceRect.height;
          const travelDistance = Math.hypot(translateX, translateY);
          const targetScale = Math.max(0.24, Math.min(0.72, Math.min(scaleX, scaleY)));
          const arcLift = Math.min(54, Math.max(18, travelDistance * 0.08));
          const midTranslateX = translateX * 0.58;
          const midTranslateY = translateY * 0.32 - arcLift;
          const highlightTarget = builderSlot?.querySelector('.mix-and-match-builder__slot-media') || builderSlot || null;
          const cleanup = () => {
            clone.remove();
            this.flashBundleTarget(highlightTarget);
          };

          if (typeof clone.animate === 'function') {
            const animation = clone.animate(
              [
                {
                  transform: 'translate3d(0, 0, 0) scale(1)',
                  opacity: 0.98,
                  filter: 'saturate(1.02) blur(0)',
                },
                {
                  transform: `translate3d(${midTranslateX}px, ${midTranslateY}px, 0) scale(0.78)`,
                  opacity: 0.9,
                  filter: 'saturate(1.04) blur(0)',
                  offset: 0.48,
                },
                {
                  transform: `translate3d(${translateX}px, ${translateY}px, 0) scale(${targetScale})`,
                  opacity: 0.08,
                  filter: 'saturate(0.98) blur(0.35px)',
                },
              ],
              {
                duration: 420,
                easing: 'cubic-bezier(0.18, 0.9, 0.22, 1)',
                fill: 'forwards',
              }
            );

            animation.finished
              .catch(() => undefined)
              .finally(cleanup);

            return;
          }

          window.requestAnimationFrame(() => {
            clone.style.transition = 'transform 0.42s cubic-bezier(0.18, 0.9, 0.22, 1), opacity 0.42s ease, filter 0.42s ease';
            clone.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${targetScale})`;
            clone.style.opacity = '0.08';
            clone.style.filter = 'saturate(0.98) blur(0.35px)';
          });

          window.setTimeout(cleanup, 440);
        });
      });
    }

    flashBundleTarget(targetElement) {
      if (!targetElement) return;

      if (targetElement.bundleArrivalTimer) {
        clearTimeout(targetElement.bundleArrivalTimer);
      }

      targetElement.classList.remove('is-arrival-target');

      window.requestAnimationFrame(() => {
        targetElement.classList.add('is-arrival-target');
      });

      targetElement.bundleArrivalTimer = window.setTimeout(() => {
        targetElement.classList.remove('is-arrival-target');
        targetElement.bundleArrivalTimer = null;
      }, 460);
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    getCartNotice() {
      if (!this.cartNotice) {
        this.cartNotice = document.createElement('div');
        this.cartNotice.className = 'mixed-catalog__cart-notice';
        this.cartNotice.setAttribute('role', 'status');
        this.cartNotice.setAttribute('aria-live', 'polite');
        this.applyCartNoticeColors(this.cartNotice);
        document.body.appendChild(this.cartNotice);
      }

      return this.cartNotice;
    }

    applyCartNoticeColors(notice) {
      if (!notice) return;

      const styles = window.getComputedStyle(this);
      const backgroundColor = styles.getPropertyValue('--mc-button-background').trim();
      const backgroundHoverColor = styles.getPropertyValue('--mc-button-background-hover').trim();
      const textColor = styles.getPropertyValue('--mc-page-background').trim();

      if (backgroundColor) {
        notice.style.background = backgroundColor;
      }

      if (backgroundHoverColor) {
        notice.style.borderColor = backgroundHoverColor;
      }

      if (textColor) {
        notice.style.color = textColor;
      }
    }

    showCartNotice(message = 'Added to cart') {
      const notice = this.getCartNotice();
      this.applyCartNoticeColors(notice);
      notice.textContent = message;
      notice.classList.add('is-visible');

      if (this.cartNoticeTimer) {
        clearTimeout(this.cartNoticeTimer);
      }

      this.cartNoticeTimer = window.setTimeout(() => {
        notice.classList.remove('is-visible');
      }, 2200);
    }

    handleCartUpdated(event) {
      const cartState = event.detail?.cart;
      if (!cartState) return;

      this.syncCardQuantities(cartState);
    }

    emitCartUpdated(cartState) {
      if (!cartState) return;

      document.dispatchEvent(
        new CustomEvent('superior:cart-updated', {
          detail: { cart: cartState },
        })
      );
    }

    async fetchCartState() {
      const response = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    }

    normalizeLineItemProperties(properties) {
      if (!properties || typeof properties !== 'object') return {};

      return Object.entries(properties).reduce((normalizedProperties, [key, value]) => {
        if (value === undefined || value === null || value === '') return normalizedProperties;

        normalizedProperties[key] = `${value}`;
        return normalizedProperties;
      }, {});
    }

    propertiesMatch(lineItemProperties, expectedProperties) {
      const normalizedLineItemProperties = this.normalizeLineItemProperties(lineItemProperties);
      const normalizedExpectedProperties = this.normalizeLineItemProperties(expectedProperties);
      const lineItemKeys = Object.keys(normalizedLineItemProperties).sort();
      const expectedKeys = Object.keys(normalizedExpectedProperties).sort();

      if (lineItemKeys.length !== expectedKeys.length) return false;

      return expectedKeys.every(
        (key, index) => lineItemKeys[index] === key && normalizedLineItemProperties[key] === normalizedExpectedProperties[key]
      );
    }

    findCartLineForCard(card, cartState) {
      const variantId = Number.parseInt(card?.dataset.variantId || '', 10);
      if (!Number.isFinite(variantId) || !Array.isArray(cartState?.items)) return null;

      const expectedProperties = this.getAgentLineItemProperties() || {};

      return cartState.items.find(
        (item) => item.variant_id === variantId && this.propertiesMatch(item.properties, expectedProperties)
      ) || null;
    }

    getCardQuantity(card) {
      const quantity = Number.parseInt(card?.dataset.cartQuantity || '', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
    }

    updateCardQuantityUi(card, quantity) {
      if (!card) return;

      const buttonGroup = card.querySelector('[data-cart-button-group]');
      const quantityActions = card.querySelector('[data-cart-quantity-actions]');
      const quantityNode = card.querySelector('[data-cart-quantity]');
      const buyButton = card.querySelector('[data-product-action="buy-now"]');
      const addButton = card.querySelector('[data-product-action="add-to-cart"]');
      const incrementButton = card.querySelector('[data-product-action="increment-cart-quantity"]');
      const decrementButton = card.querySelector('[data-product-action="decrement-cart-quantity"]');
      const isAvailable = card.dataset.variantAvailable === 'true';
      const isUpdating = card.dataset.cartUpdating === 'true';

      card.dataset.cartQuantity = `${quantity}`;

      if (quantityNode) {
        quantityNode.textContent = `${quantity}`;
      }

      if (buttonGroup) {
        buttonGroup.hidden = quantity > 0;
      }

      if (quantityActions) {
        quantityActions.hidden = quantity <= 0;
      }

      if (buyButton) {
        buyButton.disabled = isUpdating || !isAvailable;
      }

      if (addButton) {
        addButton.disabled = isUpdating || !isAvailable;
      }

      if (incrementButton) {
        incrementButton.disabled = isUpdating || !isAvailable;
      }

      if (decrementButton) {
        decrementButton.disabled = isUpdating;
      }
    }

    setCardUpdating(card, isUpdating) {
      if (!card) return;

      card.dataset.cartUpdating = isUpdating ? 'true' : 'false';
      this.updateCardQuantityUi(card, this.getCardQuantity(card));
    }

    async syncCardQuantities(cartState = null) {
      let resolvedCartState = cartState;

      if (!resolvedCartState) {
        try {
          resolvedCartState = await this.fetchCartState();
        } catch (error) {
          console.error(error);
          return;
        }
      }

      this.productCards.forEach((card) => {
        const cartLine = this.findCartLineForCard(card, resolvedCartState);
        card.dataset.cartLineKey = cartLine?.key || '';
        this.updateCardQuantityUi(card, cartLine?.quantity || 0);
      });
    }

    isCartStateResponse(payload) {
      return Number.isFinite(payload?.item_count) && Array.isArray(payload?.items);
    }

    async syncCartUiAfterMutation(payload = null) {
      await this.refreshCartUi(payload);

      const cartState = this.isCartStateResponse(payload) ? payload : await this.fetchCartState();

      this.emitCartUpdated(cartState);
      return cartState;
    }

    async updateCartLineQuantity(lineKey, quantity, triggerElement) {
      const cart = this.getCartElement();
      const sectionsToRender = this.getCartSectionsToRender(cart);
      const payload = {
        id: lineKey,
        quantity,
      };

      if (sectionsToRender.length) {
        payload.sections = sectionsToRender.map((section) => section.section || section.id);
        payload.sections_url = this.getSectionsUrl();
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(triggerElement);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Cart update failed');
      }

      return data;
    }

    async changeCardQuantity(card, nextQuantity, triggerElement) {
      if (!card) return false;

      const variantId = card.dataset.variantId;
      if (!variantId) return false;

      this.setCardUpdating(card, true);

      try {
        let responsePayload;
        const currentQuantity = this.getCardQuantity(card);
        const lineKey = card.dataset.cartLineKey || '';

        if (nextQuantity <= 0) {
          if (!lineKey) {
            await this.syncCardQuantities();
            return false;
          }

          responsePayload = await this.updateCartLineQuantity(lineKey, 0, triggerElement);
        } else if (currentQuantity <= 0 || !lineKey) {
          responsePayload = await this.addItemToCart(variantId, triggerElement, false, {
            renderCart: false,
            redirectToCartOnNoCart: false,
            deferUiRefresh: true,
          });
        } else {
          responsePayload = await this.updateCartLineQuantity(lineKey, nextQuantity, triggerElement);
        }

        await this.syncCartUiAfterMutation(responsePayload);
        return true;
      } catch (error) {
        console.error(error);
        await this.syncCardQuantities();
        return false;
      } finally {
        this.setCardUpdating(card, false);
      }
    }

    getBundleItems(button) {
      return (button.dataset.bundleVariantIds || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
        .map((id) => ({ id, quantity: 1 }));
    }

    getAgentLineItemProperties() {
      if (!this.agentOrigin) return null;

      const properties = {
        _agent_origin: this.agentOrigin,
      };

      if (Number.isFinite(this.agentShopMoq) && this.agentShopMoq > 0) {
        properties._agent_shop_moq = `${this.agentShopMoq}`;
      }

      if (Number.isFinite(this.agentShopDiscount) && this.agentShopDiscount > 0) {
        properties._agent_shop_discount = `${this.agentShopDiscount}`;
      }

      return properties;
    }

    getAgentMinimumQuantity() {
      if (Number.isFinite(this.agentShopMoq) && this.agentShopMoq > 0) {
        return this.agentShopMoq;
      }

      if (Number.isFinite(this.bundleBuilderMoq) && this.bundleBuilderMoq > 0) {
        return this.bundleBuilderMoq;
      }

      return 15;
    }

    shouldRedirectAgentOrderToCart(items = []) {
      if (!this.agentOrigin) return false;

      const totalQuantity = items.reduce((quantity, item) => {
        const itemQuantity = Number.parseInt(item.quantity, 10) || 0;
        return quantity + Math.max(itemQuantity, 0);
      }, 0);

      return totalQuantity < this.getAgentMinimumQuantity();
    }

    async buyNow(variantId, button) {
      const originalMarkup = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Loading...';

      try {
        const shouldRedirectToCart = this.shouldRedirectAgentOrderToCart([{ id: variantId, quantity: 1 }]);
        await fetch('/cart/clear.js', { method: 'POST' });

        if (shouldRedirectToCart) {
          await this.addItemToCart(variantId, button, false, {
            renderCart: false,
            redirectToCartOnNoCart: false,
          });
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }

        await this.addItemToCart(variantId, button, true);
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.innerHTML = originalMarkup;
      }
    }

    async buyBundleNow(items, button) {
      const originalMarkup = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Loading...';

      try {
        const shouldRedirectToCart = this.shouldRedirectAgentOrderToCart(items);
        await fetch('/cart/clear.js', { method: 'POST' });

        if (shouldRedirectToCart) {
          await this.addBundleItems(items, button, { redirectToCart: true, includeSections: false });
          return;
        }

        await this.addBundleItems(items, button, { redirectToCheckout: true, includeSections: false });
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.innerHTML = originalMarkup;
      }
    }

    async addToCart(variantId, button) {
      const card = button.closest('[data-cart-product-card]');

      if (!card) {
        try {
          await this.addItemToCart(variantId, button, false, {
            renderCart: false,
            redirectToCartOnNoCart: false,
          });
        } catch (error) {
          console.error(error);
        }

        return;
      }

      await this.changeCardQuantity(card, this.getCardQuantity(card) + 1, button);
    }

    async addBundleToCart(items, button) {
      const originalMarkup = button.innerHTML;
      button.disabled = true;

      try {
        await this.addBundleItems(items, button);
        this.showCartNotice('Bundle added to cart');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg>';
        window.setTimeout(() => {
          button.innerHTML = originalMarkup;
          button.disabled = false;
        }, 1400);
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.innerHTML = originalMarkup;
      }
    }

    async checkoutBundleBuilder(button) {
      const store = this.getBundleBuilderStore();
      if (store && typeof store.checkout === 'function') {
        try {
          const result = await store.checkout();
          if (result && result.ok === false && result.message) {
            this.showCartNotice(result.message);
          }
        } catch (error) {
          console.error(error);
          this.showCartNotice('Unable to add bundle to cart');
        }
        return;
      }

      const items = this.getBundleBuilderItems().map((item) => ({
        id: item.id,
        quantity: item.quantity,
      }));

      if (!items.length || this.getBundleBuilderTotalQuantity() < this.bundleBuilderMoq) {
        this.showCartNotice(this.formatBundleStatus(this.getBundleBuilderTotalQuantity()));
        return;
      }

      this.bundleCheckoutPending = true;
      this.updateBundleBuilderUi();

      try {
        await this.addBundleItems(items, button, {
          redirectToCart: true,
          includeSections: false,
        });
      } catch (error) {
        console.error(error);
        this.showCartNotice('Unable to add bundle to cart');
        this.bundleCheckoutPending = false;
        this.updateBundleBuilderUi();
      }
    }

    async addBundleItems(items, button, options = {}) {
      const {
        redirectToCheckout = false,
        redirectToCart = false,
        includeSections = !redirectToCheckout && !redirectToCart,
      } = options;
      const cart = this.getCartElement();

      if (!items.length) {
        throw new Error('No bundle items found');
      }

      const payload = {
        items: items.map((item) => {
          const cartItem = {
            id: item.id,
            quantity: item.quantity || 1,
          };
          const agentLineItemProperties = this.getAgentLineItemProperties();

          if (agentLineItemProperties) {
            cartItem.properties = { ...agentLineItemProperties };
          }

          return cartItem;
        }),
      };

      const sectionsToRender = includeSections ? this.getCartSectionsToRender(cart) : [];

      if (sectionsToRender.length) {
        payload.sections = sectionsToRender.map((section) => section.section || section.id);
        payload.sections_url = this.getSectionsUrl();
      }

      const addUrl = window.routes?.cart_add_url ? `${window.routes.cart_add_url}.js` : '/cart/add.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Add failed');
      }

      if (redirectToCheckout) {
        window.location.href = '/checkout';
        return;
      }

      if (redirectToCart) {
        window.location.href = window.routes?.cart_url || '/cart';
        return;
      }

      await this.syncCartUiAfterMutation(data);
    }

    getCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    getCartSectionsToRender(cart = this.getCartElement()) {
      if (!cart) return [];

      if (cart.tagName === 'CART-DRAWER') {
        const cartItems = cart.querySelector('cart-drawer-items');

        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          return cartItems.getSectionsToRender();
        }
      }

      if (typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender();
      }

      return [];
    }

    getSectionsUrl() {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('section_id');
      return `${currentUrl.pathname}${currentUrl.search}`;
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHtml.querySelector(selector) || parsedHtml.body;

      return source.innerHTML;
    }

    syncCartDrawerState(sectionHtml, cart = this.getCartElement()) {
      if (!sectionHtml || !cart || cart.tagName !== 'CART-DRAWER') return;

      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sourceCartDrawer = parsedHtml.querySelector('cart-drawer');
      const sourceCartDrawerItems = parsedHtml.querySelector('cart-drawer-items');

      if (sourceCartDrawer) {
        cart.classList.toggle('is-empty', sourceCartDrawer.classList.contains('is-empty'));
        return;
      }

      if (sourceCartDrawerItems) {
        cart.classList.toggle('is-empty', sourceCartDrawerItems.classList.contains('is-empty'));
      }
    }

    updateCartUi(sections, cart = this.getCartElement()) {
      if (!sections) return false;

      const sectionsToRender = this.getCartSectionsToRender(cart);

      if (!sectionsToRender.length) {
        if (sections['cart-icon-bubble']) {
          updateCartIconBubble(sections['cart-icon-bubble']);
          return true;
        }

        return false;
      }

      sectionsToRender.forEach((section) => {
        const sectionId = section.section || section.id;
        const sectionHtml = sections[sectionId] || sections[section.id];
        if (!sectionHtml) return;

        if (sectionId === 'cart-drawer') {
          this.syncCartDrawerState(sectionHtml, cart);
        }

        if (section.id === 'cart-icon-bubble') {
          updateCartIconBubble(sectionHtml, section.selector || '.shopify-section');
          return;
        }

        const sectionRoot = document.getElementById(section.id);
        const sectionElement =
          sectionRoot && section.selector ? sectionRoot.querySelector(section.selector) || sectionRoot : sectionRoot;
        const targetElement = sectionElement || (section.selector ? document.querySelector(section.selector) : null);
        if (!targetElement) return;

        targetElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      return true;
    }

    async refreshCartUi(parsedState = null) {
      const cart = this.getCartElement();

      if (parsedState?.sections && this.updateCartUi(parsedState.sections, cart)) {
        return;
      }

      const sectionUrl = new URL(window.location.href);
      const sectionIds = this.getCartSectionsToRender(cart)
        .map((section) => section.section || section.id)
        .filter(Boolean);

      if (!sectionIds.length) {
        sectionIds.push('cart-icon-bubble');
      }

      sectionUrl.searchParams.set('sections', [...new Set(sectionIds)].join(','));
      sectionUrl.searchParams.delete('section_id');

      const response = await fetch(sectionUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const sections = await response.json();

      this.updateCartUi(sections, cart);
    }

    async updateCartCountBubble() {
      await this.refreshCartUi();
    }

    async addItemToCart(variantId, button, redirectToCheckout, options = {}) {
      const cart = this.getCartElement();
      const quantity = options.quantity || 1;
      const renderCart = options.renderCart !== false;
      const redirectToCartOnNoCart = options.redirectToCartOnNoCart !== false;
      const deferUiRefresh = options.deferUiRefresh === true;
      const config = fetchConfig('javascript');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', `${quantity}`);

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const agentLineItemProperties = this.getAgentLineItemProperties();
      if (agentLineItemProperties) {
        Object.entries(agentLineItemProperties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
      }

      const sectionsToRender = this.getCartSectionsToRender(cart);

      if (sectionsToRender.length) {
        formData.append('sections', sectionsToRender.map((section) => section.section || section.id).join(','));
        formData.append('sections_url', this.getSectionsUrl());
        if (renderCart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      config.body = formData;

      const response = await fetch(window.routes?.cart_add_url || '/cart/add', config);
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Add failed');
      }

      if (redirectToCheckout) {
        window.location.href = '/checkout';
        return data;
      }

      if (!deferUiRefresh && cart && renderCart && typeof cart.renderContents === 'function') {
        cart.renderContents(data, { shouldOpen: false });
        return data;
      }

      if (!deferUiRefresh) {
        await this.refreshCartUi(data);

        if (!cart && redirectToCartOnNoCart) {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      }

      return data;
    }
  }

  if (!customElements.get('mixed-catalog-grid')) {
    customElements.define('mixed-catalog-grid', MixedCatalogGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-bundles-slider"] && !Shopify.designMode) return;
  try {
    
  class RelatedBundlesSlider extends HTMLElement {
    connectedCallback() {
      this.sliderWrapper = this.querySelector('.rb-slider-wrapper');
      this.slider = this.querySelector('.rb-slider');
      this.slides = Array.from(this.querySelectorAll('.rb-slide'));
      this.prevBtn = this.querySelector('button[name="previous"]');
      this.nextBtn = this.querySelector('button[name="next"]');
      this.dots = Array.from(this.querySelectorAll('.rb-dot'));
      this.dotsContainer = this.querySelector('.rb-dots');

      if (!this.slider || !this.slides.length) return;

      this.currentIndex = 0;
      this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed, 10) || 3500;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.agentContext = this.getAgentContext();

      this.handleResize = this.handleResize.bind(this);
      this.handleActionClick = this.handleActionClick.bind(this);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number.parseInt(dot.dataset.index, 10));
          this.resetAutoplay();
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('click', this.handleActionClick);

      this.slider.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.touches[0].clientX;
        },
        { passive: true }
      );

      this.slider.addEventListener('touchend', (event) => {
        const diff = this.touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          this.goTo(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
          this.resetAutoplay();
        }
      });

      window.addEventListener('resize', this.handleResize);

      this.querySelectorAll('.rb-retail-price').forEach((element) => {
        const numericValue = Number.parseFloat(element.dataset.price);
        if (!Number.isNaN(numericValue)) {
          element.textContent = numericValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
      });

      this.applyAgentContext();
      this.updateDots();
      this.play();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.pause();
      this.removeEventListener('click', this.handleActionClick);
    }

    get slidesPerPage() {
      return window.innerWidth >= 990 ? 4 : 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.slidesPerPage);
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.slider.style.transition = 'none';
        this.applyTransform();
        this.updateDots();
        requestAnimationFrame(() => {
          this.slider.style.transition = '';
        });
      }, 100);
    }

    getStep() {
      if (this.slides.length < 2) return this.sliderWrapper.offsetWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    applyTransform() {
      this.slider.style.transform = `translateX(-${this.currentIndex * this.getStep()}px)`;
    }

    goTo(index) {
      const max = this.maxIndex;
      if (index < 0) index = max;
      if (index > max) index = 0;
      this.currentIndex = index;
      this.applyTransform();
      this.updateDots();
    }

    updateDots() {
      const max = this.maxIndex;
      const hasMultiplePages = max > 0;
      let visibleDots = 0;

      this.slider.classList.toggle('rb-slider--centered', !hasMultiplePages);

      if (this.prevBtn) {
        this.prevBtn.hidden = !hasMultiplePages;
        this.prevBtn.disabled = !hasMultiplePages;
      }

      if (this.nextBtn) {
        this.nextBtn.hidden = !hasMultiplePages;
        this.nextBtn.disabled = !hasMultiplePages;
      }

      this.dots.forEach((dot, index) => {
        const visible = index <= max;
        const active = visible && index === this.currentIndex;

        dot.hidden = !visible;
        dot.disabled = !visible;
        dot.tabIndex = visible ? 0 : -1;
        dot.classList.toggle('rb-dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');

        if (visible) visibleDots += 1;
      });

      if (this.dotsContainer) {
        this.dotsContainer.hidden = visibleDots < 2;
      }
    }

    play() {
      this.pause();
      if (!this.autoplaySpeed || this.maxIndex === 0) return;
      this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pause() {
      clearInterval(this.autoplayTimer);
    }

    resetAutoplay() {
      this.pause();
      this.play();
    }

    getAgentContext() {
      const origin = this.dataset.sectionAgentOrigin || new URLSearchParams(window.location.search).get('agent_origin');

      if (origin !== 'agent-shop') return null;

      return {
        origin,
        moq: this.parsePositiveInteger(this.dataset.sectionAgentMoq),
        discountOverride: this.parsePositivePercentage(this.dataset.sectionAgentDiscount),
      };
    }

    parsePositiveInteger(value) {
      const parsedValue = Number.parseInt(String(value ?? ''), 10);
      return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
    }

    parsePositivePercentage(value) {
      const parsedValue = Number.parseFloat(String(value ?? ''));
      if (!Number.isFinite(parsedValue) || parsedValue <= 0) return null;
      return Math.min(parsedValue, 100);
    }

    isBundleCard(card) {
      return String(card?.dataset.productType || '').trim().toLowerCase() === 'bundle';
    }

    getEffectiveDiscount(card) {
      if (!this.agentContext) return null;
      return this.agentContext.discountOverride ?? null;
    }

    getAgentLineItemProperties() {
      if (!this.agentContext) return null;

      const properties = {
        _agent_origin: this.agentContext.origin,
      };

      if (Number.isFinite(this.agentContext.moq) && this.agentContext.moq > 0) {
        properties._agent_shop_moq = `${this.agentContext.moq}`;
      }

      if (Number.isFinite(this.agentContext.discountOverride) && this.agentContext.discountOverride > 0) {
        properties._agent_shop_discount = `${this.agentContext.discountOverride}`;
      }

      return properties;
    }

    formatMoney(cents) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = this.moneyFormat.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';
      const amount = Number(cents) / 100;

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (Number.isNaN(number) || number === null) return '0';

        const fixedNumber = number.toFixed(precision);
        const parts = fixedNumber.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        return parts.join(decimal);
      };

      let formattedValue;
      switch (placeholder) {
        case 'amount_no_decimals':
          formattedValue = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          formattedValue = formatWithDelimiters(amount, 2);
          break;
      }

      return this.moneyFormat.replace(placeholderRegex, formattedValue);
    }

    buildProductUrl(card) {
      const baseUrl = card?.dataset.productUrl;
      if (!baseUrl || !this.agentContext) return baseUrl || '';

      const params = new URLSearchParams();
      params.set('agent_origin', this.agentContext.origin);

      if (Number.isFinite(this.agentContext.moq) && this.agentContext.moq > 0) {
        params.set('agent_shop_moq', `${this.agentContext.moq}`);
      }

      if (Number.isFinite(this.agentContext.discountOverride) && this.agentContext.discountOverride > 0) {
        params.set('agent_shop_discount', `${this.agentContext.discountOverride}`);
      }

      const queryString = params.toString();
      if (!queryString) return baseUrl;

      return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${queryString}`;
    }

    applyAgentContext() {
      this.querySelectorAll('[data-related-bundle-card]').forEach((card) => {
        const productLink = card.querySelector('[data-product-link]');
        if (productLink) {
          productLink.href = this.buildProductUrl(card) || productLink.href;
        }

        const priceNode = card.querySelector('[data-related-bundle-price]');
        if (!priceNode) return;

        const basePriceCents = Number.parseInt(priceNode.dataset.basePriceCents, 10);
        if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) return;

        const effectiveDiscount = this.getEffectiveDiscount(card);
        const discountedPriceCents = effectiveDiscount
          ? Math.round((basePriceCents * (100 - effectiveDiscount)) / 100)
          : basePriceCents;

        priceNode.textContent = this.formatMoney(discountedPriceCents);
      });
    }

    handleActionClick(event) {
      const button = event.target.closest('[data-product-action]');
      if (!button) return;

      event.preventDefault();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const action = button.dataset.productAction;
      if (action === 'buy-now') {
        this.buyNow(variantId, button);
      }

      if (action === 'add-to-cart') {
        this.addToCart(variantId, button);
      }
    }

    getCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    getCartSectionsToRender(cart = this.getCartElement()) {
      if (!cart) return [];

      if (cart.tagName === 'CART-DRAWER') {
        const cartItems = cart.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          return cartItems.getSectionsToRender();
        }
      }

      if (typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender();
      }

      return [];
    }

    async refreshCartBubble() {
      const cartResponse = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const cart = await cartResponse.json();

      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const countElement = bubble.querySelector('[aria-hidden="true"]');
        if (countElement) countElement.textContent = cart.item_count;
        if (cart.item_count > 0) {
          bubble.removeAttribute('hidden');
        } else {
          bubble.setAttribute('hidden', 'hidden');
        }
      });
    }

    async addToCart(variantId, button) {
      const originalMarkup = button.innerHTML;
      button.disabled = true;

      try {
        const cart = this.getCartElement();
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
        };

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const agentLineItemProperties = this.getAgentLineItemProperties();
        if (agentLineItemProperties) {
          Object.entries(agentLineItemProperties).forEach(([key, value]) => {
            formData.append(`properties[${key}]`, value);
          });
        }

        const sectionsToRender = this.getCartSectionsToRender(cart);
        if (sectionsToRender.length) {
          formData.append('sections', sectionsToRender.map((section) => section.section || section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }

        config.body = formData;

        const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config);
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'Add failed');

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data, { shouldOpen: false });
        } else {
          await this.refreshCartBubble();
        }

        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true" focusable="false"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(() => {
          button.innerHTML = originalMarkup;
          button.disabled = false;
        }, 1200);
      } catch (error) {
        button.innerHTML = originalMarkup;
        button.disabled = false;
        console.error(error);
      }
    }

    async buyNow(variantId, button) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading...';

      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        const cartItem = { id: variantId, quantity: 1 };
        const agentLineItemProperties = this.getAgentLineItemProperties();
        if (agentLineItemProperties) {
          cartItem.properties = agentLineItemProperties;
        }

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [cartItem],
          }),
        });

        if (!addResponse.ok) throw new Error('Add failed');
        window.location.href = '/checkout';
      } catch (error) {
        button.textContent = originalText;
        button.disabled = false;
        console.error(error);
      }
    }
  }

  if (!customElements.get('related-bundles-slider')) {
    customElements.define('related-bundles-slider', RelatedBundlesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-slider"] && !Shopify.designMode) return;
  try {
    
  class RelatedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.sliderWrapper = this.querySelector('.rp-slider-wrapper');
      this.slider = this.querySelector('.rp-slider');
      this.slides = Array.from(this.querySelectorAll('.rp-slide'));
      this.productCards = Array.from(this.querySelectorAll('[data-related-product-card]'));
      this.prevBtn = this.querySelector('button[name="previous"]');
      this.nextBtn = this.querySelector('button[name="next"]');
      this.dots = Array.from(this.querySelectorAll('.rp-dot'));
      this.dotsContainer = this.querySelector('.rp-dots');

      if (!this.slider || !this.slides.length) return;

      this.currentIndex = 0;
      this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed, 10) || 3500;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.agentContext = this.getAgentContext();

      this.handleResize = this.handleResize.bind(this);
      this.handleActionClick = this.handleActionClick.bind(this);
      this.handleCartUpdated = this.handleCartUpdated.bind(this);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number.parseInt(dot.dataset.index, 10));
          this.resetAutoplay();
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('click', this.handleActionClick);
      document.addEventListener('superior:cart-updated', this.handleCartUpdated);

      this.slider.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.touches[0].clientX;
        },
        { passive: true }
      );

      this.slider.addEventListener('touchend', (event) => {
        const diff = this.touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          this.goTo(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
          this.resetAutoplay();
        }
      });

      window.addEventListener('resize', this.handleResize);

      this.querySelectorAll('.rp-retail-price').forEach((element) => {
        const numericValue = Number.parseFloat(element.dataset.price);
        if (!Number.isNaN(numericValue)) {
          element.textContent = numericValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
      });

      this.applyAgentContext();
      this.updateDots();
      this.play();
      this.syncCardQuantities();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.pause();
      this.removeEventListener('click', this.handleActionClick);
      document.removeEventListener('superior:cart-updated', this.handleCartUpdated);
    }

    get slidesPerPage() {
      return window.innerWidth >= 990 ? 4 : 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.slidesPerPage);
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.slider.style.transition = 'none';
        this.applyTransform();
        this.updateDots();
        requestAnimationFrame(() => {
          this.slider.style.transition = '';
        });
      }, 100);
    }

    getStep() {
      if (this.slides.length < 2) return this.sliderWrapper.offsetWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    applyTransform() {
      this.slider.style.transform = `translateX(-${this.currentIndex * this.getStep()}px)`;
    }

    goTo(index) {
      const max = this.maxIndex;
      if (index < 0) index = max;
      if (index > max) index = 0;
      this.currentIndex = index;
      this.applyTransform();
      this.updateDots();
    }

    updateDots() {
      const max = this.maxIndex;
      const hasMultiplePages = max > 0;
      let visibleDots = 0;

      if (this.prevBtn) {
        this.prevBtn.hidden = !hasMultiplePages;
        this.prevBtn.disabled = !hasMultiplePages;
      }

      if (this.nextBtn) {
        this.nextBtn.hidden = !hasMultiplePages;
        this.nextBtn.disabled = !hasMultiplePages;
      }

      this.dots.forEach((dot, index) => {
        const visible = index <= max;
        const active = visible && index === this.currentIndex;

        dot.hidden = !visible;
        dot.disabled = !visible;
        dot.tabIndex = visible ? 0 : -1;
        dot.classList.toggle('rp-dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');

        if (visible) visibleDots += 1;
      });

      if (this.dotsContainer) {
        this.dotsContainer.hidden = visibleDots < 2;
      }
    }

    play() {
      this.pause();
      if (!this.autoplaySpeed || this.maxIndex === 0) return;
      this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pause() {
      clearInterval(this.autoplayTimer);
    }

    resetAutoplay() {
      this.pause();
      this.play();
    }

    getAgentContext() {
      const origin = this.dataset.sectionAgentOrigin || new URLSearchParams(window.location.search).get('agent_origin');

      if (origin !== 'agent-shop') return null;

      return {
        origin,
        moq: this.parsePositiveInteger(this.dataset.sectionAgentMoq),
        discountOverride: this.parsePositivePercentage(this.dataset.sectionAgentDiscount),
      };
    }

    parsePositiveInteger(value) {
      const parsedValue = Number.parseInt(String(value ?? ''), 10);
      return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
    }

    parsePositivePercentage(value) {
      const parsedValue = Number.parseFloat(String(value ?? ''));
      if (!Number.isFinite(parsedValue) || parsedValue <= 0) return null;
      return Math.min(parsedValue, 100);
    }

    isBundleCard(card) {
      return String(card?.dataset.productType || '').trim().toLowerCase() === 'bundle';
    }

    getEffectiveDiscount(card) {
      if (!this.agentContext) return null;
      return this.agentContext.discountOverride ?? null;
    }

    getAgentLineItemProperties(card) {
      if (!this.agentContext) return null;

      const properties = {
        _agent_origin: this.agentContext.origin,
      };

      if (Number.isFinite(this.agentContext.moq) && this.agentContext.moq > 0) {
        properties._agent_shop_moq = `${this.agentContext.moq}`;
      }

      if (Number.isFinite(this.agentContext.discountOverride) && this.agentContext.discountOverride > 0) {
        properties._agent_shop_discount = `${this.agentContext.discountOverride}`;
      }

      return properties;
    }

    formatMoney(cents) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = this.moneyFormat.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';
      const amount = Number(cents) / 100;

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (Number.isNaN(number) || number === null) return '0';

        const fixedNumber = number.toFixed(precision);
        const parts = fixedNumber.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        return parts.join(decimal);
      };

      let formattedValue;
      switch (placeholder) {
        case 'amount_no_decimals':
          formattedValue = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          formattedValue = formatWithDelimiters(amount, 2);
          break;
      }

      return this.moneyFormat.replace(placeholderRegex, formattedValue);
    }

    buildProductUrl(card) {
      const baseUrl = card?.dataset.productUrl;
      if (!baseUrl || !this.agentContext) return baseUrl || '';

      const params = new URLSearchParams();
      if (this.isBundleCard(card)) {
        params.set('agent_origin', this.agentContext.origin);
      } else {
        params.set('view', 'agent-product');
      }

      const queryString = params.toString();
      if (!queryString) return baseUrl;

      return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${queryString}`;
    }

    applyAgentContext() {
      this.querySelectorAll('[data-related-product-card]').forEach((card) => {
        const productLink = card.querySelector('[data-product-link]');
        if (productLink) {
          productLink.href = this.buildProductUrl(card) || productLink.href;
        }

        const priceNode = card.querySelector('[data-related-price]');
        if (!priceNode) return;

        const basePriceCents = Number.parseInt(priceNode.dataset.basePriceCents, 10);
        if (!Number.isFinite(basePriceCents)) return;

        const effectiveDiscount = this.getEffectiveDiscount(card);
        const discountedPriceCents = effectiveDiscount
          ? Math.round(basePriceCents * (100 - effectiveDiscount) / 100)
          : basePriceCents;

        priceNode.textContent = this.formatMoney(discountedPriceCents);
      });
    }

    handleCartUpdated(event) {
      const cartState = event.detail?.cart;
      if (!cartState) return;

      this.syncCardQuantities(cartState);
    }

    emitCartUpdated(cartState) {
      if (!cartState) return;

      document.dispatchEvent(
        new CustomEvent('superior:cart-updated', {
          detail: { cart: cartState },
        })
      );
    }

    getSectionsUrl() {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('section_id');
      return `${currentUrl.pathname}${currentUrl.search}`;
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHtml.querySelector(selector) || parsedHtml.body;

      return source.innerHTML;
    }

    syncCartDrawerState(sectionHtml, cart = this.getCartElement()) {
      if (!sectionHtml || !cart || cart.tagName !== 'CART-DRAWER') return;

      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sourceCartDrawer = parsedHtml.querySelector('cart-drawer');
      const sourceCartDrawerItems = parsedHtml.querySelector('cart-drawer-items');

      if (sourceCartDrawer) {
        cart.classList.toggle('is-empty', sourceCartDrawer.classList.contains('is-empty'));
        return;
      }

      if (sourceCartDrawerItems) {
        cart.classList.toggle('is-empty', sourceCartDrawerItems.classList.contains('is-empty'));
      }
    }

    updateCartUi(sections, cart = this.getCartElement()) {
      if (!sections) return false;

      const sectionsToRender = this.getCartSectionsToRender(cart);

      if (!sectionsToRender.length) {
        if (sections['cart-icon-bubble']) {
          updateCartIconBubble(sections['cart-icon-bubble']);
          return true;
        }

        return false;
      }

      sectionsToRender.forEach((section) => {
        const sectionId = section.section || section.id;
        const sectionHtml = sections[sectionId] || sections[section.id];
        if (!sectionHtml) return;

        if (sectionId === 'cart-drawer') {
          this.syncCartDrawerState(sectionHtml, cart);
        }

        if (section.id === 'cart-icon-bubble') {
          updateCartIconBubble(sectionHtml, section.selector || '.shopify-section');
          return;
        }

        const sectionRoot = document.getElementById(section.id);
        const sectionElement =
          sectionRoot && section.selector ? sectionRoot.querySelector(section.selector) || sectionRoot : sectionRoot;
        const targetElement = sectionElement || (section.selector ? document.querySelector(section.selector) : null);
        if (!targetElement) return;

        targetElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      return true;
    }

    async refreshCartUi(parsedState = null) {
      const cart = this.getCartElement();

      if (parsedState?.sections && this.updateCartUi(parsedState.sections, cart)) {
        return;
      }

      const sectionUrl = new URL(window.location.href);
      const sectionIds = this.getCartSectionsToRender(cart)
        .map((section) => section.section || section.id)
        .filter(Boolean);

      if (!sectionIds.length) {
        sectionIds.push('cart-icon-bubble');
      }

      sectionUrl.searchParams.set('sections', [...new Set(sectionIds)].join(','));
      sectionUrl.searchParams.delete('section_id');

      const response = await fetch(sectionUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const sections = await response.json();

      this.updateCartUi(sections, cart);
    }

    updateCartBubbleCount(itemCount) {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const countElement = bubble.querySelector('[aria-hidden="true"]');
        if (countElement) countElement.textContent = itemCount;

        if (itemCount > 0) {
          bubble.removeAttribute('hidden');
        } else {
          bubble.setAttribute('hidden', 'hidden');
        }
      });
    }

    async fetchCartState() {
      const response = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    }

    normalizeLineItemProperties(properties) {
      if (!properties || typeof properties !== 'object') return {};

      return Object.entries(properties).reduce((normalizedProperties, [key, value]) => {
        if (value === undefined || value === null || value === '') return normalizedProperties;

        normalizedProperties[key] = `${value}`;
        return normalizedProperties;
      }, {});
    }

    propertiesMatch(lineItemProperties, expectedProperties) {
      const normalizedLineItemProperties = this.normalizeLineItemProperties(lineItemProperties);
      const normalizedExpectedProperties = this.normalizeLineItemProperties(expectedProperties);
      const lineItemKeys = Object.keys(normalizedLineItemProperties).sort();
      const expectedKeys = Object.keys(normalizedExpectedProperties).sort();

      if (lineItemKeys.length !== expectedKeys.length) return false;

      return expectedKeys.every(
        (key, index) => lineItemKeys[index] === key && normalizedLineItemProperties[key] === normalizedExpectedProperties[key]
      );
    }

    findCartLineForCard(card, cartState) {
      const variantId = Number.parseInt(card?.dataset.variantId || '', 10);
      if (!Number.isFinite(variantId) || !Array.isArray(cartState?.items)) return null;

      const expectedProperties = this.getAgentLineItemProperties(card) || {};

      return cartState.items.find(
        (item) => item.variant_id === variantId && this.propertiesMatch(item.properties, expectedProperties)
      ) || null;
    }

    getCardQuantity(card) {
      const quantity = Number.parseInt(card?.dataset.cartQuantity || '', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
    }

    updateCardQuantityUi(card, quantity) {
      if (!card) return;

      const buttonGroup = card.querySelector('[data-cart-button-group]');
      const quantityActions = card.querySelector('[data-cart-quantity-actions]');
      const quantityNode = card.querySelector('[data-cart-quantity]');
      const buyButton = card.querySelector('[data-product-action="buy-now"]');
      const addButton = card.querySelector('[data-product-action="add-to-cart"]');
      const incrementButton = card.querySelector('[data-product-action="increment-cart-quantity"]');
      const decrementButton = card.querySelector('[data-product-action="decrement-cart-quantity"]');
      const isAvailable = card.dataset.variantAvailable === 'true';
      const isUpdating = card.dataset.cartUpdating === 'true';

      card.dataset.cartQuantity = `${quantity}`;

      if (quantityNode) {
        quantityNode.textContent = `${quantity}`;
      }

      if (buttonGroup) {
        buttonGroup.hidden = quantity > 0;
      }

      if (quantityActions) {
        quantityActions.hidden = quantity <= 0;
      }

      if (buyButton) {
        buyButton.disabled = isUpdating || !isAvailable;
      }

      if (addButton) {
        addButton.disabled = isUpdating || !isAvailable;
      }

      if (incrementButton) {
        incrementButton.disabled = isUpdating || !isAvailable;
      }

      if (decrementButton) {
        decrementButton.disabled = isUpdating;
      }
    }

    setCardUpdating(card, isUpdating) {
      if (!card) return;

      card.dataset.cartUpdating = isUpdating ? 'true' : 'false';
      this.updateCardQuantityUi(card, this.getCardQuantity(card));
    }

    async syncCardQuantities(cartState = null) {
      let resolvedCartState = cartState;

      if (!resolvedCartState) {
        try {
          resolvedCartState = await this.fetchCartState();
        } catch (error) {
          console.error(error);
          return;
        }
      }

      this.productCards.forEach((card) => {
        const cartLine = this.findCartLineForCard(card, resolvedCartState);
        card.dataset.cartLineKey = cartLine?.key || '';
        this.updateCardQuantityUi(card, cartLine?.quantity || 0);
      });
    }

    isCartStateResponse(payload) {
      return Number.isFinite(payload?.item_count) && Array.isArray(payload?.items);
    }

    async syncCartUiAfterMutation(payload) {
      await this.refreshCartUi(payload);

      const cartState = this.isCartStateResponse(payload) ? payload : await this.fetchCartState();

      this.emitCartUpdated(cartState);
      return cartState;
    }

    async addItemToCart(variantId, triggerElement, card, quantity = 1) {
      const cart = this.getCartElement();
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      };

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', `${quantity}`);

      const agentLineItemProperties = this.getAgentLineItemProperties(card);
      if (agentLineItemProperties) {
        Object.entries(agentLineItemProperties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
      }

      const sectionsToRender = this.getCartSectionsToRender(cart);
      if (sectionsToRender.length) {
        formData.append('sections', sectionsToRender.map((section) => section.section || section.id).join(','));
        formData.append('sections_url', this.getSectionsUrl());
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(triggerElement);
      }

      config.body = formData;

      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config);
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Add failed');

      return data;
    }

    async updateCartLineQuantity(lineKey, quantity, triggerElement) {
      const cart = this.getCartElement();
      const sectionsToRender = this.getCartSectionsToRender(cart);
      const payload = {
        id: lineKey,
        quantity,
      };

      if (sectionsToRender.length) {
        payload.sections = sectionsToRender.map((section) => section.section || section.id);
        payload.sections_url = this.getSectionsUrl();
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(triggerElement);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Cart update failed');
      }

      return data;
    }

    async changeCardQuantity(card, nextQuantity, triggerElement) {
      if (!card) return false;

      const variantId = card.dataset.variantId;
      if (!variantId) return false;

      this.setCardUpdating(card, true);

      try {
        let responsePayload;
        const currentQuantity = this.getCardQuantity(card);
        const lineKey = card.dataset.cartLineKey || '';

        if (nextQuantity <= 0) {
          if (!lineKey) {
            await this.syncCardQuantities();
            return false;
          }

          responsePayload = await this.updateCartLineQuantity(lineKey, 0, triggerElement);
        } else if (currentQuantity <= 0 || !lineKey) {
          responsePayload = await this.addItemToCart(variantId, triggerElement, card, 1);
        } else {
          responsePayload = await this.updateCartLineQuantity(lineKey, nextQuantity, triggerElement);
        }

        await this.syncCartUiAfterMutation(responsePayload);
        return true;
      } catch (error) {
        console.error(error);
        await this.syncCardQuantities();
        return false;
      } finally {
        this.setCardUpdating(card, false);
      }
    }

    handleActionClick(event) {
      const button = event.target.closest('[data-product-action]');
      if (!button) return;

      event.preventDefault();

      const card = button.closest('[data-related-product-card]');
      if (!card) return;

      const action = button.dataset.productAction;
      if (action === 'increment-cart-quantity') {
        this.changeCardQuantity(card, this.getCardQuantity(card) + 1, button);
        return;
      }

      if (action === 'decrement-cart-quantity') {
        this.changeCardQuantity(card, this.getCardQuantity(card) - 1, button);
        return;
      }

      const variantId = button.dataset.variantId || card.dataset.variantId;
      if (!variantId) return;

      if (action === 'buy-now') {
        this.buyNow(variantId, button, card);
      }

      if (action === 'add-to-cart') {
        this.addToCart(variantId, button, card);
      }
    }

    getCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    getCartSectionsToRender(cart = this.getCartElement()) {
      if (!cart) return [];

      if (cart.tagName === 'CART-DRAWER') {
        const cartItems = cart.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          return cartItems.getSectionsToRender();
        }
      }

      if (typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender();
      }

      return [];
    }

    async refreshCartBubble() {
      const cart = await this.fetchCartState();
      this.updateCartBubbleCount(cart.item_count);
      return cart;
    }

    async addToCart(variantId, button, card) {
      await this.changeCardQuantity(card, this.getCardQuantity(card) + 1, button);
    }

    async buyNow(variantId, button, card) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading...';

      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        const cartItem = { id: variantId, quantity: 1 };
        const agentLineItemProperties = this.getAgentLineItemProperties(card);
        if (agentLineItemProperties) {
          cartItem.properties = agentLineItemProperties;
        }

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [cartItem],
          }),
        });

        if (!addResponse.ok) throw new Error('Add failed');
        window.location.href = '/checkout';
      } catch (error) {
        button.textContent = originalText;
        button.disabled = false;
        console.error(error);
      }
    }
  }

  if (!customElements.get('related-products-slider')) {
    customElements.define('related-products-slider', RelatedProductsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.sliderWrapper = this.querySelector('.rv-slider-wrapper');
      this.slider        = this.querySelector('.rv-slider');
      this.slides        = Array.from(this.querySelectorAll('.rv-slide'));
      this.prevBtn       = this.querySelector('.rv-nav--prev');
      this.nextBtn       = this.querySelector('.rv-nav--next');
      this.dots          = Array.from(this.querySelectorAll('.rv-dot'));

      if (!this.slider || !this.slides.length) return;

      this.currentIndex  = 0;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 4000;
      this.autoplayTimer = null;
      this.touchStartX   = 0;

      this.prevBtn.addEventListener('click', () => { this.goTo(this.currentIndex - 1); this.resetAutoplay(); });
      this.nextBtn.addEventListener('click', () => { this.goTo(this.currentIndex + 1); this.resetAutoplay(); });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.index));
          this.resetAutoplay();
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());

      this.slider.addEventListener('touchstart', (e) => { this.touchStartX = e.touches[0].clientX; }, { passive: true });
      this.slider.addEventListener('touchend', (e) => {
        const diff = this.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          this.goTo(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
          this.resetAutoplay();
        }
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.slider.style.transition = 'none';
          this.applyTransform();
          requestAnimationFrame(() => { this.slider.style.transition = ''; });
        }, 100);
      });

      this.updateDots();
      this.play();
    }

    get slidesPerPage() {
      return window.innerWidth >= 750 ? 3 : 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.slidesPerPage);
    }

    getStep() {
      if (this.slides.length < 2) return this.sliderWrapper.offsetWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    applyTransform() {
      this.slider.style.transform = `translateX(-${this.currentIndex * this.getStep()}px)`;
    }

    goTo(index) {
      const max = this.maxIndex;
      if (index < 0)   index = max;
      if (index > max) index = 0;
      this.currentIndex = index;
      this.applyTransform();
      this.updateDots();
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        const active = i === this.currentIndex;
        dot.classList.toggle('rv-dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    play() {
      this.pause();
      if (!this.autoplaySpeed) return;
      this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pause() { clearInterval(this.autoplayTimer); }

    resetAutoplay() { this.pause(); this.play(); }
  }

  if (!customElements.get('reviews-carousel')) {
    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
